import {CssColor, StyleType, wixColor} from '@wix/editor-platform-ooi-metadata-resolver'
import {colorToRgba} from '@wix/panda-js-utils'
import {IStyleParam, StyleParamType, createStylesParams, wixColorParam} from '@wix/tpa-settings'
import {
  ALIGNMENT,
  BUTTONS_STYLE,
  CALENDAR_LAYOUT,
  DEFAULT_WEEK_START,
  EVENT_BADGE_LAYOUT,
  IMAGE_ALIGNMENT,
  IMAGE_HOVER_EFFECT,
  IMAGE_RATIO,
  IMAGE_SCALING,
  ITEM_HEIGHT_TYPE,
  LIST_ALIGNMENT,
  LIST_IMAGE_LAYOUT,
  LIST_IMAGE_SIZE,
  LIST_LAYOUT,
  LIST_LAYOUT_TYPE,
  LIST_LOCATION_AND_DATE_FORMAT,
  MOBILE_LIST_LAYOUT,
  MOBILE_LIST_LAYOUT_TYPE,
  MOBILE_WIDGET_LAYOUT,
  ON_IMAGE_CARD_HEIGHT_BEHAVIOR,
  VERTICAL_ALIGNMENT,
  WIDGET_LAYOUT,
  WIDGET_TYPE,
} from '@wix/wix-events-commons-statics'
import {Override} from '../../commons/types/utils'
import {getDefaultFont} from '../../settings-commons/utils/style'
import {ISettingsNumbers, WidgetComponentTextSettings} from './settingsParams'
import {
  DeprecatedBooleans,
  DeprecatedColors,
  DeprecatedFonts,
  DeprecatedNumbers,
  createDeprecatedStyles,
} from './stylesParams/deprecated-styles'
import {
  getWidgetDateVisibilityDefault,
  getWidgetLocationDateFormatDefault,
  getWidgetLocationVisibilityDefault,
} from './Widget/style-helpers/new-styles'
import {WidgetText} from './Widget/style-helpers/studio/constants'
import {getV2ParamsMap} from './Widget/style-helpers/studio/mapper'
import {
  getSocialShareDefault,
  getWidgetButtonDefaultFont,
  getWidgetFontColorDefault,
  getWidgetFontDefault,
} from './Widget/style-helpers/studio/utils'

type IStylesNumbers = {
  borderWidth: StyleParamType.Number
  todayButtonBorderWidth: StyleParamType.Number
  todayButtonBorderRadius: StyleParamType.Number
  listRoundedButtonBorderRadius: StyleParamType.Number
  calendarCellBorderWidth: StyleParamType.Number
  calendarCellBorderWidthNew: StyleParamType.Number
  calendarBorderWidth: StyleParamType.Number
  buttonsBorderWidth: StyleParamType.Number
  todayRoundedButtonBorderRadius: StyleParamType.Number
  listButtonBorderRadius: StyleParamType.Number
  listButtonBorderWidth: StyleParamType.Number
  calendarDetailsTitleTextSize: StyleParamType.Number
  calendarDetailsDateLocationTextSize: StyleParamType.Number
  calendarDetailsDescriptionTextSize: StyleParamType.Number
  widgetType: StyleParamType.Number
  listLayout: StyleParamType.Number
  listLayoutType: StyleParamType.Number
  mobileListLayout: StyleParamType.Number
  mobileWidgetLayout: StyleParamType.Number
  mobileListLayoutType: StyleParamType.Number
  mobileWidgetLayoutNew: StyleParamType.Number
  mobileWidgetListLayoutType: StyleParamType.Number
  widgetLayout: StyleParamType.Number
  alignment: StyleParamType.Number
  contentAlignment: StyleParamType.Number
  listAlignment: StyleParamType.Number
  imagePosition: StyleParamType.Number
  verticalImagePosition: StyleParamType.Number
  imageGridPosition: StyleParamType.Number
  imageScaling: StyleParamType.Number
  multiImageScaling: StyleParamType.Number
  multiImageRatio: StyleParamType.Number
  listImageSize: StyleParamType.Number
  /**
   * @deprecated
   */
  imageRatio: StyleParamType.Number
  listImageLayout: StyleParamType.Number
  locationAndDateFormat: StyleParamType.Number
  cardsPerRow: StyleParamType.Number
  buttonsStyle: StyleParamType.Number
  buttonsBorderRadius: StyleParamType.Number
  roundedButtonsBorderRadius: StyleParamType.Number
  buttonHeight: StyleParamType.Number
  oneButtonWidth: StyleParamType.Number
  verticalDividerWidth: StyleParamType.Number
  verticalDividerHeight: StyleParamType.Number
  horizontalDividerWidth: StyleParamType.Number
  horizontalDividerHeight: StyleParamType.Number
  compactHorizontalDividerWidth: StyleParamType.Number
  compactHorizontalDividerHeight: StyleParamType.Number
  countdownMarginBottom: StyleParamType.Number
  titleMarginBottom: StyleParamType.Number
  descriptionMarginBottom: StyleParamType.Number
  dateMarginBottom: StyleParamType.Number
  locationMarginBottom: StyleParamType.Number
  dateAndLocationMarginBottom: StyleParamType.Number
  rsvpMarginBottom: StyleParamType.Number
  imageWidth: StyleParamType.Number
  imageOpacity: StyleParamType.Number
  listButtonStyle: StyleParamType.Number
  gapBetweenCards: StyleParamType.Number
  /**
   * @deprecated
   */
  listImageOpacity: StyleParamType.Number
  multiImageOpacity: StyleParamType.Number
  multiImageTopMargin: StyleParamType.Number
  multiImageBottomMargin: StyleParamType.Number
  multiImageLeftMargin: StyleParamType.Number
  multiImageRightMargin: StyleParamType.Number
  multiImagePosition: StyleParamType.Number
  multiImageBorderWidth: StyleParamType.Number
  multiImageTopLeftBorderRadius: StyleParamType.Number
  multiImageTopRightBorderRadius: StyleParamType.Number
  multiImageBottomLeftBorderRadius: StyleParamType.Number
  multiImageBottomRightBorderRadius: StyleParamType.Number
  listImageWidth: StyleParamType.Number
  calendarImageOpacity: StyleParamType.Number
  calendarImagePosition: StyleParamType.Number
  calendarImageBorderWidth: StyleParamType.Number
  calendarImageTopLeftBorderRadius: StyleParamType.Number
  calendarImageTopRightBorderRadius: StyleParamType.Number
  calendarImageBottomLeftBorderRadius: StyleParamType.Number
  calendarImageBottomRightBorderRadius: StyleParamType.Number
  calendarWeekStartDay: StyleParamType.Number
  calendarListTextSize: StyleParamType.Number
  calendarListDividerWidth: StyleParamType.Number
  todayButtonStyle: StyleParamType.Number
  recurringFilter: StyleParamType.Number
  listLocationAndDateFormatV2: StyleParamType.Number
  listCountdownTopLeftBorderRadius: StyleParamType.Number
  listCountdownTopRightBorderRadius: StyleParamType.Number
  listCountdownBottomLeftBorderRadius: StyleParamType.Number
  listCountdownBottomRightBorderRadius: StyleParamType.Number
  listTopMargin: StyleParamType.Number
  listBottomMargin: StyleParamType.Number
  listLeftMargin: StyleParamType.Number
  listRightMargin: StyleParamType.Number
  listItemTopPadding: StyleParamType.Number
  listItemBottomPadding: StyleParamType.Number
  listItemLeftPadding: StyleParamType.Number
  listItemRightPadding: StyleParamType.Number
  itemFixedHeight: StyleParamType.Number
  itemHeightType: StyleParamType.Number
  topLeftBorderRadius: StyleParamType.Number
  topRightBorderRadius: StyleParamType.Number
  bottomLeftBorderRadius: StyleParamType.Number
  bottomRightBorderRadius: StyleParamType.Number
  eventBoxShadowDistance: StyleParamType.Number
  eventBoxShadowBlur: StyleParamType.Number
  eventBoxShadowAngle: StyleParamType.Number
  listImageHoverEffect: StyleParamType.Number
  listTextVerticalAlignment: StyleParamType.Number
  listItemBorderAndDividerWidth: StyleParamType.Number
  widgetBorderWidth: StyleParamType.Number
  onImageCardHeightBehavior: StyleParamType.Number
  eventBadgeLayout: StyleParamType.Number
  eventBadgeVerticalAlignment: StyleParamType.Number
  eventBadgeHorizontalAlignment: StyleParamType.Number
  calendarEventBadgeLayout: StyleParamType.Number
  calendarEventBadgeVerticalAlignment: StyleParamType.Number
  calendarEventBadgeHorizontalAlignment: StyleParamType.Number
  firstPriorityEventBadgeBorderWidth: StyleParamType.Number
  secondPriorityEventBadgeBorderWidth: StyleParamType.Number
  thirdPriorityEventBadgeBorderWidth: StyleParamType.Number
  firstPriorityEventBadgeTopLeftBorderRadius: StyleParamType.Number
  firstPriorityEventBadgeTopRightBorderRadius: StyleParamType.Number
  firstPriorityEventBadgeBottomLeftBorderRadius: StyleParamType.Number
  firstPriorityEventBadgeBottomRightBorderRadius: StyleParamType.Number
  secondPriorityEventBadgeTopLeftBorderRadius: StyleParamType.Number
  secondPriorityEventBadgeTopRightBorderRadius: StyleParamType.Number
  secondPriorityEventBadgeBottomLeftBorderRadius: StyleParamType.Number
  secondPriorityEventBadgeBottomRightBorderRadius: StyleParamType.Number
  thirdPriorityEventBadgeTopLeftBorderRadius: StyleParamType.Number
  thirdPriorityEventBadgeTopRightBorderRadius: StyleParamType.Number
  thirdPriorityEventBadgeBottomLeftBorderRadius: StyleParamType.Number
  thirdPriorityEventBadgeBottomRightBorderRadius: StyleParamType.Number
  firstPriorityCalendarEventBadgeBorderWidth: StyleParamType.Number
  secondPriorityCalendarEventBadgeBorderWidth: StyleParamType.Number
  thirdPriorityCalendarEventBadgeBorderWidth: StyleParamType.Number
  firstPriorityCalendarEventBadgeTopLeftBorderRadius: StyleParamType.Number
  firstPriorityCalendarEventBadgeTopRightBorderRadius: StyleParamType.Number
  firstPriorityCalendarEventBadgeBottomLeftBorderRadius: StyleParamType.Number
  firstPriorityCalendarEventBadgeBottomRightBorderRadius: StyleParamType.Number
  secondPriorityCalendarEventBadgeTopLeftBorderRadius: StyleParamType.Number
  secondPriorityCalendarEventBadgeTopRightBorderRadius: StyleParamType.Number
  secondPriorityCalendarEventBadgeBottomLeftBorderRadius: StyleParamType.Number
  secondPriorityCalendarEventBadgeBottomRightBorderRadius: StyleParamType.Number
  thirdPriorityCalendarEventBadgeTopLeftBorderRadius: StyleParamType.Number
  thirdPriorityCalendarEventBadgeTopRightBorderRadius: StyleParamType.Number
  thirdPriorityCalendarEventBadgeBottomLeftBorderRadius: StyleParamType.Number
  thirdPriorityCalendarEventBadgeBottomRightBorderRadius: StyleParamType.Number
  calendarTopMargin: StyleParamType.Number
  calendarBottomMargin: StyleParamType.Number
  calendarLeftMargin: StyleParamType.Number
  calendarRightMargin: StyleParamType.Number
  calendarHeight: StyleParamType.Number
  calendarGridTopPadding: StyleParamType.Number
  calendarGridBottomPadding: StyleParamType.Number
  calendarGridLeftPadding: StyleParamType.Number
  calendarGridRightPadding: StyleParamType.Number
  calendarGridHorizontalGap: StyleParamType.Number
  calendarGridVerticalGap: StyleParamType.Number
  calendarGridBorderWidth: StyleParamType.Number
  calendarGridTopLeftBorderRadius: StyleParamType.Number
  calendarGridTopRightBorderRadius: StyleParamType.Number
  calendarGridBottomLeftBorderRadius: StyleParamType.Number
  calendarGridBottomRightBorderRadius: StyleParamType.Number
  calendarGridBoxShadowDistance: StyleParamType.Number
  calendarGridBoxShadowAngle: StyleParamType.Number
  calendarGridBoxShadowBlur: StyleParamType.Number
  calendarCellTopLeftBorderRadius: StyleParamType.Number
  calendarCellTopRightBorderRadius: StyleParamType.Number
  calendarCellBottomLeftBorderRadius: StyleParamType.Number
  calendarCellBottomRightBorderRadius: StyleParamType.Number
  calendarCellBoxShadowDistance: StyleParamType.Number
  calendarCellBoxShadowAngle: StyleParamType.Number
  calendarCellBoxShadowBlur: StyleParamType.Number
  calendarCellTopPadding: StyleParamType.Number
  calendarCellBottomPadding: StyleParamType.Number
  calendarCellLeftPadding: StyleParamType.Number
  calendarCellRightPadding: StyleParamType.Number
  calendarCellHorizontalAlignment: StyleParamType.Number
  calendarHeaderBorderWidth: StyleParamType.Number
  calendarHeaderTopLeftBorderRadius: StyleParamType.Number
  calendarHeaderTopRightBorderRadius: StyleParamType.Number
  calendarHeaderBottomLeftBorderRadius: StyleParamType.Number
  calendarHeaderBottomRightBorderRadius: StyleParamType.Number
  calendarHeaderTopPadding: StyleParamType.Number
  calendarHeaderRightPadding: StyleParamType.Number
  calendarHeaderBottomPadding: StyleParamType.Number
  calendarHeaderLeftPadding: StyleParamType.Number
  calendarHeaderBoxShadowDistance: StyleParamType.Number
  calendarHeaderBoxShadowAngle: StyleParamType.Number
  calendarHeaderBoxShadowBlur: StyleParamType.Number
  eventsPerCalendarCell: StyleParamType.Number
  calendarWeekdaysHorizontalAlignment: StyleParamType.Number
  calendarWeekdaysBottomMargin: StyleParamType.Number
  calendarLayoutType: StyleParamType.Number
  calendarPopupHorizontalAlignment: StyleParamType.Number
  calendarPopupTopPadding: StyleParamType.Number
  calendarPopupBottomPadding: StyleParamType.Number
  calendarPopupLeftPadding: StyleParamType.Number
  calendarPopupRightPadding: StyleParamType.Number
  calendarEventPopupBorderWidth: StyleParamType.Number
  calendarEventPopupTopLeftBorderRadius: StyleParamType.Number
  calendarEventPopupTopRightBorderRadius: StyleParamType.Number
  calendarEventPopupBottomLeftBorderRadius: StyleParamType.Number
  calendarEventPopupBottomRightBorderRadius: StyleParamType.Number
  calendarEventPopupBoxShadowDistance: StyleParamType.Number
  calendarEventPopupBoxShadowAngle: StyleParamType.Number
  calendarEventPopupBoxShadowBlur: StyleParamType.Number
  calendarRsvpButtonStyle: StyleParamType.Number
  calendarRsvpButtonBorderWidth: StyleParamType.Number
  calendarRoundedRsvpButtonBorderRadius: StyleParamType.Number
  calendarRsvpButtonBorderRadius: StyleParamType.Number
  calendarEventListPopupBorderWidth: StyleParamType.Number
  calendarEventListPopupTopLeftBorderRadius: StyleParamType.Number
  calendarEventListPopupTopRightBorderRadius: StyleParamType.Number
  calendarEventListPopupBottomLeftBorderRadius: StyleParamType.Number
  calendarEventListPopupBottomRightBorderRadius: StyleParamType.Number
  calendarEventListPopupBoxShadowDistance: StyleParamType.Number
  calendarEventListPopupBoxShadowAngle: StyleParamType.Number
  calendarEventListPopupBoxShadowBlur: StyleParamType.Number
  calendarImageRatio: StyleParamType.Number
  calendarImageScaling: StyleParamType.Number
  calendarImageTopMargin: StyleParamType.Number
  calendarImageBottomMargin: StyleParamType.Number
  calendarImageLeftMargin: StyleParamType.Number
  calendarImageRightMargin: StyleParamType.Number
} & DeprecatedNumbers

type IStylesBooleans = {
  showImage: StyleParamType.Boolean
  showCountdown: StyleParamType.Boolean
  showOfferRibbon: StyleParamType.Boolean
  showRecurringRibbon: StyleParamType.Boolean
  showTitle: StyleParamType.Boolean
  showDescription: StyleParamType.Boolean
  showDate: StyleParamType.Boolean
  showLocation: StyleParamType.Boolean
  showShareOptions: StyleParamType.Boolean
  showFullDividers: StyleParamType.Boolean
  showHorizontalDividers: StyleParamType.Boolean
  showCompactDividers: StyleParamType.Boolean
  showLabels: StyleParamType.Boolean
  showRSVPTitle: StyleParamType.Boolean
  showMembers: StyleParamType.Boolean
  listShowMainTitle: StyleParamType.Boolean
  listShowDescription: StyleParamType.Boolean
  listShowSocialShare: StyleParamType.Boolean
  listShowImage: StyleParamType.Boolean
  listShowAdditionalInfo: StyleParamType.Boolean
  listShowMembers: StyleParamType.Boolean
  listShowCountdown: StyleParamType.Boolean
  showSoldOutRibbon: StyleParamType.Boolean
  /**
   * @deprecated showRibbon is split into multiple other flags
   */
  showRibbon: StyleParamType.Boolean
  showRsvpClosedRibbon: StyleParamType.Boolean
  showJoinWaitlistRibbon: StyleParamType.Boolean
  listExtraInfoShowDate: StyleParamType.Boolean
  listExtraInfoShowLocation: StyleParamType.Boolean
  listShowDateV2: StyleParamType.Boolean
  listShowLocationV2: StyleParamType.Boolean
  eventBoxShadowVisible: StyleParamType.Boolean
  eventBadgeStretched: StyleParamType.Boolean
  calendarEventBadgeStretched: StyleParamType.Boolean
  showFirstPriorityEventBadge: StyleParamType.Boolean
  showSecondPriorityEventBadge: StyleParamType.Boolean
  showThirdPriorityEventBadge: StyleParamType.Boolean
  listShowLoadMore: StyleParamType.Boolean
  calendarGridBoxShadowVisible: StyleParamType.Boolean
  calendarCellBoxShadowVisible: StyleParamType.Boolean
  calendarHeaderBoxShadowVisible: StyleParamType.Boolean
  calendarEventPopupBoxShadowVisible: StyleParamType.Boolean
  calendarEventListPopupBoxShadowVisible: StyleParamType.Boolean
} & DeprecatedBooleans

type IStylesFonts = {
  calendarMonthFont: StyleParamType.Font
  calendarWeekdaysFont: StyleParamType.Font
  calendarDayNumberFont: StyleParamType.Font
  calendarDayNumberFontNew: StyleParamType.Font
  calendarCellEventNameFont: StyleParamType.Font
  calendarCellEventNameFontNew: StyleParamType.Font
  calendarCellEventTimeFont: StyleParamType.Font
  calendarCellMoreEventsFont: StyleParamType.Font
  calendarEventPopupEventNameFont: StyleParamType.Font
  calendarEventPopupFullDateFont: StyleParamType.Font
  calendarEventPopupLocationFont: StyleParamType.Font
  calendarEventPopupDescriptionFont: StyleParamType.Font
  calendarEventPopupMembersFont: StyleParamType.Font
  calendarHollowRsvpButtonFont: StyleParamType.Font
  calendarFullRsvpButtonFont: StyleParamType.Font
  calendarSoldOutRibbonFont: StyleParamType.Font
  calendarRsvpClosedRibbonFont: StyleParamType.Font
  calendarJoinWaitlistRibbonFont: StyleParamType.Font
  calendarMembershipRibbonFont: StyleParamType.Font
  calendarRecurringRibbonFont: StyleParamType.Font
  todayHollowButtonFont: StyleParamType.Font
  todayButtonFont: StyleParamType.Font
  ribbonFont: StyleParamType.Font
  soldOutRibbonFont: StyleParamType.Font
  rsvpClosedRibbonFont: StyleParamType.Font
  joinWaitlistRibbonFont: StyleParamType.Font
  membershipRibbonFont: StyleParamType.Font
  recurringRibbonFont: StyleParamType.Font
  hollowButtonsFont: StyleParamType.Font
  fullButtonsFont: StyleParamType.Font
  countdownFont: StyleParamType.Font
  titleFont: StyleParamType.Font
  descriptionFont: StyleParamType.Font
  labelsFont: StyleParamType.Font
  compactTextsFont: StyleParamType.Font
  textsFont: StyleParamType.Font
  firstPriorityEventBadgeFont: StyleParamType.Font
  secondPriorityEventBadgeFont: StyleParamType.Font
  thirdPriorityEventBadgeFont: StyleParamType.Font
  firstPriorityCalendarEventBadgeFont: StyleParamType.Font
  secondPriorityCalendarEventBadgeFont: StyleParamType.Font
  thirdPriorityCalendarEventBadgeFont: StyleParamType.Font
  categoryMenuFont: StyleParamType.Font
  calendarHeaderTitleFont: StyleParamType.Font
  calendarHeaderCategoryButtonFont: StyleParamType.Font
  calendarHeaderDatePickerButtonFont: StyleParamType.Font
  calendarEventListPopupTitleFont: StyleParamType.Font
  calendarEventListPopupEventTimeFont: StyleParamType.Font
  calendarEventListPopupEventNameFont: StyleParamType.Font

  eventTitleFontV2: StyleParamType.Font
  eventDateFontV2: StyleParamType.Font
  eventLocationFontV2: StyleParamType.Font
  eventDescriptionFontV2: StyleParamType.Font
  linkFontV2: StyleParamType.Font
  listTitleFontV2: StyleParamType.Font
  listFullButtonFontV2: StyleParamType.Font
  listHollowButtonFontV2: StyleParamType.Font
  listCountdownFont: StyleParamType.Font

  hoveredEventTitleFontV2: StyleParamType.Font
  hoveredEventDateFontV2: StyleParamType.Font
  hoveredEventLocationFontV2: StyleParamType.Font
  hoveredEventDescriptionFontV2: StyleParamType.Font
} & DeprecatedFonts

type IStylesColors = {
  calendarCellBackground: StyleParamType.Color
  calendarCellBackgroundNew: StyleParamType.Color
  calendarBorderColor: StyleParamType.Color
  calendarMainActiveColor: StyleParamType.Color
  listGeneralTitleColor: StyleParamType.Color
  calendarMonthColor: StyleParamType.Color
  calendarWeekdaysColor: StyleParamType.Color
  calendarDayNumberColor: StyleParamType.Color
  calendarCellEventNameColor: StyleParamType.Color
  calendarCellEventTimeColor: StyleParamType.Color
  calendarCellMoreEventsColor: StyleParamType.Color
  calendarCellTodayColor: StyleParamType.Color // TODO: find better name when ux & content is decided
  calendarCellWeekendBackgroundColor: StyleParamType.Color
  listHollowButtonFontColor: StyleParamType.Color
  listFullButtonFontColor: StyleParamType.Color
  todayHollowButtonColor: StyleParamType.Color
  todayButtonColor: StyleParamType.Color
  ribbonTextColor: StyleParamType.Color
  soldOutRibbonTextColor: StyleParamType.Color
  rsvpClosedRibbonTextColor: StyleParamType.Color
  joinWaitlistRibbonTextColor: StyleParamType.Color
  membershipRibbonTextColor: StyleParamType.Color
  recurringRibbonTextColor: StyleParamType.Color
  onImageHollowButtonsFontColor: StyleParamType.Color
  hollowButtonsFontColor: StyleParamType.Color
  onImageFullButtonsFontColor: StyleParamType.Color
  fullButtonsFontColor: StyleParamType.Color
  countdownColor: StyleParamType.Color
  onImageCountdownColor: StyleParamType.Color
  titleColor: StyleParamType.Color
  onImageTitleColor: StyleParamType.Color
  onImageDescriptionColor: StyleParamType.Color
  descriptionColor: StyleParamType.Color
  onImageLabelsColor: StyleParamType.Color
  labelsColor: StyleParamType.Color
  onImageTextsColor: StyleParamType.Color
  textsColor: StyleParamType.Color
  calendarCellBorderColor: StyleParamType.Color
  calendarPastDaysBackground: StyleParamType.Color
  listButtonBackgroundColor: StyleParamType.Color
  listButtonBorderColor: StyleParamType.Color
  listButtonHoverColor: StyleParamType.Color
  todayButtonBackgroundColor: StyleParamType.Color
  todayButtonBorderColor: StyleParamType.Color
  todayButtonHoverColor: StyleParamType.Color
  widgetBackgroundColor: StyleParamType.Color
  widgetBorderColor: StyleParamType.Color
  listItemBorderAndDividerColor: StyleParamType.Color
  listItemBackgroundColor: StyleParamType.Color
  /**
   * @deprecated
   */
  listImageBackgroundColor: StyleParamType.Color
  multiImageBackgroundColor: StyleParamType.Color
  multiImageBorderColor: StyleParamType.Color
  calendarImageBackgroundColor: StyleParamType.Color
  calendarImageBorderColor: StyleParamType.Color
  ribbonBackgroundColor: StyleParamType.Color
  soldOutRibbonBackgroundColor: StyleParamType.Color
  rsvpClosedRibbonBackgroundColor: StyleParamType.Color
  joinWaitlistRibbonBackgroundColor: StyleParamType.Color
  membershipRibbonBorderColor: StyleParamType.Color
  recurringRibbonBorderColor: StyleParamType.Color
  imageBackgroundColor: StyleParamType.Color
  backgroundColor: StyleParamType.Color
  borderColor: StyleParamType.Color
  onImageButtonsBorderColor: StyleParamType.Color
  buttonsBorderColor: StyleParamType.Color
  onImageButtonsBackgroundColor: StyleParamType.Color
  buttonsBackgroundColor: StyleParamType.Color
  onImageDividerColor: StyleParamType.Color
  dividerColor: StyleParamType.Color
  calendarBackgroundColor: StyleParamType.Color
  listLoadMoreContainerBackgroundColor: StyleParamType.Color
  listCountdownColor: StyleParamType.Color
  listCountdownBorderColor: StyleParamType.Color
  listCountdownBackgroundColor: StyleParamType.Color
  firstPriorityEventBadgeColor: StyleParamType.Color
  secondPriorityEventBadgeColor: StyleParamType.Color
  thirdPriorityEventBadgeColor: StyleParamType.Color
  firstPriorityEventBadgeBackgroundColor: StyleParamType.Color
  secondPriorityEventBadgeBackgroundColor: StyleParamType.Color
  thirdPriorityEventBadgeBackgroundColor: StyleParamType.Color
  firstPriorityEventBadgeBorderColor: StyleParamType.Color
  secondPriorityEventBadgeBorderColor: StyleParamType.Color
  thirdPriorityEventBadgeBorderColor: StyleParamType.Color
  firstPriorityCalendarEventBadgeColor: StyleParamType.Color
  secondPriorityCalendarEventBadgeColor: StyleParamType.Color
  thirdPriorityCalendarEventBadgeColor: StyleParamType.Color
  firstPriorityCalendarEventBadgeBackgroundColor: StyleParamType.Color
  secondPriorityCalendarEventBadgeBackgroundColor: StyleParamType.Color
  thirdPriorityCalendarEventBadgeBackgroundColor: StyleParamType.Color
  firstPriorityCalendarEventBadgeBorderColor: StyleParamType.Color
  secondPriorityCalendarEventBadgeBorderColor: StyleParamType.Color
  thirdPriorityCalendarEventBadgeBorderColor: StyleParamType.Color
  calendarGridBackgroundColor: StyleParamType.Color
  calendarGridBorderColor: StyleParamType.Color
  calendarGridBoxShadowColor: StyleParamType.Color
  calendarCellBoxShadowColor: StyleParamType.Color
  calendarHeaderTitleColor: StyleParamType.Color
  calendarHeaderCategoryButtonColor: StyleParamType.Color
  calendarHeaderDatePickerButtonColor: StyleParamType.Color
  calendarHeaderBorderColor: StyleParamType.Color
  calendarHeaderBackgroundColor: StyleParamType.Color
  calendarEventPopupEventNameColor: StyleParamType.Color
  calendarEventPopupFullDateColor: StyleParamType.Color
  calendarEventPopupLocationColor: StyleParamType.Color
  calendarEventPopupDescriptionColor: StyleParamType.Color
  calendarEventPopupMembersColor: StyleParamType.Color
  calendarEventPopupShareIconsColor: StyleParamType.Color
  calendarEventPopupBackgroundColor: StyleParamType.Color
  calendarEventPopupBorderColor: StyleParamType.Color
  calendarEventPopupBoxShadowColor: StyleParamType.Color
  calendarFullRsvpButtonBackgroundColor: StyleParamType.Color
  calendarHollowRsvpButtonFontColor: StyleParamType.Color
  calendarFullRsvpButtonFontColor: StyleParamType.Color
  calendarHollowRsvpButtonBorderColor: StyleParamType.Color
  calendarRsvpButtonHoverColor: StyleParamType.Color
  calendarSoldOutRibbonTextColor: StyleParamType.Color
  calendarRsvpClosedRibbonTextColor: StyleParamType.Color
  calendarJoinWaitlistRibbonTextColor: StyleParamType.Color
  calendarMembershipRibbonTextColor: StyleParamType.Color
  calendarRecurringRibbonTextColor: StyleParamType.Color
  calendarSoldOutRibbonBackgroundColor: StyleParamType.Color
  calendarRsvpClosedRibbonBackgroundColor: StyleParamType.Color
  calendarJoinWaitlistRibbonBackgroundColor: StyleParamType.Color
  calendarMembershipRibbonBorderColor: StyleParamType.Color
  calendarRecurringRibbonBorderColor: StyleParamType.Color
  calendarEventListPopupBoxShadowColor: StyleParamType.Color
  calendarEventListPopupTitleColor: StyleParamType.Color
  calendarEventListPopupEventTimeColor: StyleParamType.Color
  calendarEventListPopupEventNameColor: StyleParamType.Color
  calendarEventListPopupDividerColor: StyleParamType.Color
  calendarEventListPopupBackgroundColor: StyleParamType.Color
  calendarEventListPopupBorderColor: StyleParamType.Color
  calendarCellHoverColor: StyleParamType.Color
  eventTitleColorV2: StyleParamType.Color
  eventDateColorV2: StyleParamType.Color
  eventLocationColorV2: StyleParamType.Color
  eventDescriptionColorV2: StyleParamType.Color
  linkColorV2: StyleParamType.Color

  hoveredEventTitleColorV2: StyleParamType.Color
  hoveredEventDateColorV2: StyleParamType.Color
  hoveredEventLocationColorV2: StyleParamType.Color
  hoveredEventDescriptionColor: StyleParamType.Color
  shareIconsColorV2: StyleParamType.Color
  eventBoxShadowColor: StyleParamType.Color
  calendarHeaderBoxShadowColor: StyleParamType.Color
  imageOverlayColor: StyleParamType.Color
  categoryMenuColor: StyleParamType.Color
  categoryMenuDividerColor: StyleParamType.Color
  categoryMenuSelectedUnderlineColor: StyleParamType.Color
} & DeprecatedColors

type ParamsMapper<Type, Val> = {
  [Property in keyof Type]: Val
}

export type WidgetStyleParams = {
  numbers: ParamsMapper<IStylesNumbers, number>
  booleans: ParamsMapper<IStylesBooleans, boolean> & {responsive: boolean; __IS_RTL__: boolean}
  colors: IStylesColors
  fonts: IStylesFonts
  strings: any
}

export type IStyles = IStylesNumbers & IStylesBooleans & IStylesColors & IStylesFonts

export type WidgetComponentSettings = Override<IStylesNumbers & ISettingsNumbers, number> &
  Override<IStylesBooleans, boolean> & {texts: WidgetComponentTextSettings} & {responsive: boolean}

const customColor = (value: string) => ({
  value,
  name: null,
  opacity: 1,
})

type IWidgetStyles = {
  listLayout: StyleParamType.Number
  listLayoutType: StyleParamType.Number
  mobileListLayout: StyleParamType.Number
  listShowImage: StyleParamType.Boolean
  mobileWidgetLayout: StyleParamType.Number
  mobileListLayoutType: StyleParamType.Number
  widgetType: StyleParamType.Number
  listTitleFontV2: StyleParamType.Font
  eventTitleColorV2: StyleParamType.Color
  eventDateColorV2: StyleParamType.Color
  eventLocationColorV2: StyleParamType.Color
  eventDescriptionColorV2: StyleParamType.Color
  linkColorV2: StyleParamType.Color
  shareIconsColorV2: StyleParamType.Color
  eventTitleFontV2: StyleParamType.Font
  eventDateFontV2: StyleParamType.Font
  eventLocationFontV2: StyleParamType.Font
  eventDescriptionFontV2: StyleParamType.Font
  linkFontV2: StyleParamType.Font
  listFullButtonFontV2: StyleParamType.Font
  listHollowButtonFontV2: StyleParamType.Font
  listTopMargin: StyleParamType.Number
  listBottomMargin: StyleParamType.Number
  listLeftMargin: StyleParamType.Number
  listRightMargin: StyleParamType.Number
  calendarCellEventNameFont: StyleParamType.Font
  calendarMainActiveColor: StyleParamType.Color
  multiImageRatio: StyleParamType.Number
  multiImageScaling: StyleParamType.Number
  multiImageTopMargin: StyleParamType.Number
  multiImageBottomMargin: StyleParamType.Number
  multiImageLeftMargin: StyleParamType.Number
  multiImageRightMargin: StyleParamType.Number
  listGeneralTitleColor: StyleParamType.Color
  listButtonStyle: StyleParamType.Number
  listButtonBorderColor: StyleParamType.Color
  listButtonBackgroundColor: StyleParamType.Color
  todayButtonStyle: StyleParamType.Number
  todayButtonBackgroundColor: StyleParamType.Color
  todayButtonBorderColor: StyleParamType.Color
  calendarDetailsTitleTextSize: StyleParamType.Number
  calendarCellEventNameColor: StyleParamType.Color
  calendarDetailsDateLocationTextSize: StyleParamType.Number
  calendarDetailsDescriptionTextSize: StyleParamType.Number
  listHollowButtonFontColor: StyleParamType.Color
  listFullButtonFontColor: StyleParamType.Color
  listButtonBorderWidth: StyleParamType.Number
  listRoundedButtonBorderRadius: StyleParamType.Number
  listButtonBorderRadius: StyleParamType.Number
  listButtonHoverColor: StyleParamType.Color
  calendarCellBackground: StyleParamType.Color
  calendarCellBorderWidth: StyleParamType.Number
  soldOutRibbonFont: StyleParamType.Font
  rsvpClosedRibbonFont: StyleParamType.Font
  joinWaitlistRibbonFont: StyleParamType.Font
  membershipRibbonFont: StyleParamType.Font
  recurringRibbonFont: StyleParamType.Font
  soldOutRibbonTextColor: StyleParamType.Color
  rsvpClosedRibbonTextColor: StyleParamType.Color
  joinWaitlistRibbonTextColor: StyleParamType.Color
  membershipRibbonTextColor: StyleParamType.Color
  recurringRibbonTextColor: StyleParamType.Color
  soldOutRibbonBackgroundColor: StyleParamType.Color
  rsvpClosedRibbonBackgroundColor: StyleParamType.Color
  joinWaitlistRibbonBackgroundColor: StyleParamType.Color
  membershipRibbonBorderColor: StyleParamType.Color
  recurringRibbonBorderColor: StyleParamType.Color
  calendarListTextSize: StyleParamType.Number
  multiImageOpacity: StyleParamType.Number
  multiImagePosition: StyleParamType.Number
  multiImageBorderWidth: StyleParamType.Number
  multiImageTopLeftBorderRadius: StyleParamType.Number
  multiImageTopRightBorderRadius: StyleParamType.Number
  multiImageBottomLeftBorderRadius: StyleParamType.Number
  multiImageBottomRightBorderRadius: StyleParamType.Number
  multiImageBackgroundColor: StyleParamType.Color
  multiImageBorderColor: StyleParamType.Color
  firstPriorityEventBadgeFont: StyleParamType.Font
  secondPriorityEventBadgeFont: StyleParamType.Font
  thirdPriorityEventBadgeFont: StyleParamType.Font
  firstPriorityEventBadgeColor: StyleParamType.Color
  secondPriorityEventBadgeColor: StyleParamType.Color
  thirdPriorityEventBadgeColor: StyleParamType.Color
  firstPriorityEventBadgeBackgroundColor: StyleParamType.Color
  secondPriorityEventBadgeBackgroundColor: StyleParamType.Color
  thirdPriorityEventBadgeBackgroundColor: StyleParamType.Color
  firstPriorityEventBadgeBorderColor: StyleParamType.Color
  secondPriorityEventBadgeBorderColor: StyleParamType.Color
  thirdPriorityEventBadgeBorderColor: StyleParamType.Color
  firstPriorityEventBadgeBorderWidth: StyleParamType.Number
  secondPriorityEventBadgeBorderWidth: StyleParamType.Number
  thirdPriorityEventBadgeBorderWidth: StyleParamType.Number
  firstPriorityEventBadgeTopLeftBorderRadius: StyleParamType.Number
  firstPriorityEventBadgeTopRightBorderRadius: StyleParamType.Number
  firstPriorityEventBadgeBottomLeftBorderRadius: StyleParamType.Number
  firstPriorityEventBadgeBottomRightBorderRadius: StyleParamType.Number
  secondPriorityEventBadgeTopLeftBorderRadius: StyleParamType.Number
  secondPriorityEventBadgeTopRightBorderRadius: StyleParamType.Number
  secondPriorityEventBadgeBottomLeftBorderRadius: StyleParamType.Number
  secondPriorityEventBadgeBottomRightBorderRadius: StyleParamType.Number
  thirdPriorityEventBadgeTopLeftBorderRadius: StyleParamType.Number
  thirdPriorityEventBadgeTopRightBorderRadius: StyleParamType.Number
  thirdPriorityEventBadgeBottomLeftBorderRadius: StyleParamType.Number
  thirdPriorityEventBadgeBottomRightBorderRadius: StyleParamType.Number
  mobileWidgetLayoutNew: StyleParamType.Number
  mobileWidgetListLayoutType: StyleParamType.Number
  eventBadgeLayout: StyleParamType.Number
  eventBadgeVerticalAlignment: StyleParamType.Number
  eventBadgeHorizontalAlignment: StyleParamType.Number
  eventBadgeStretched: StyleParamType.Boolean
  calendarDayNumberFont: StyleParamType.Font
  calendarRsvpButtonStyle: StyleParamType.Number
  calendarHollowRsvpButtonBorderColor: StyleParamType.Color
  calendarFullRsvpButtonBackgroundColor: StyleParamType.Color
}

const deprecatedStyles = createDeprecatedStyles()
const paramsMap = getV2ParamsMap(deprecatedStyles)

const getDefaultListMargin: IStyleParam['getDefaultValue'] = ({isMobile, getStyleParamValue}) => {
  const layout = getStyleParamValue(widgetStyles.listLayout)

  return isMobile
    ? 20
    : [LIST_LAYOUT.NEW_GRID, LIST_LAYOUT.GRID].includes(layout)
    ? getStyleParamValue(deprecatedStyles.cardMargins)
    : [LIST_LAYOUT.SIDE_BY_SIDE, LIST_LAYOUT.CALENDAR, LIST_LAYOUT.ON_IMAGE].includes(layout)
    ? 20
    : 30
}

const getDefaultRibbonColor: IStyleParam['getDefaultValue'] = params => {
  const {isMobile, getStyleParamValue} = params
  const showImage = getStyleParamValue(widgetStyles.listShowImage)
  const onImage = isMobile
    ? getStyleParamValue(widgetStyles.mobileWidgetLayoutNew) === MOBILE_WIDGET_LAYOUT.ON_IMAGE
    : getStyleParamValue(widgetStyles.listLayout) === LIST_LAYOUT.ON_IMAGE

  return onImage && showImage ? wixColorParam('color-1')(params) : wixColorParam('color-5')(params)
}

export const widgetStyles = createStylesParams<IWidgetStyles>({
  // if not set defaults to imageRatio
  multiImageRatio: {
    type: StyleParamType.Number,
    getDefaultValue: () => undefined,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: IMAGE_RATIO['1:1'],
      },
      ai: {
        description: 'Event image aspect ratio can be: 1 - 1:1, 2 - 16:9',
      },
    },
  },
  multiImageScaling: {
    type: StyleParamType.Number,
    getDefaultValue: () => IMAGE_SCALING.CROP,
    metadata: {
      type: StyleType.numberEnum,
      defaultValue: {
        type: 'static',
        value: IMAGE_SCALING.CROP,
      },
      ai: {
        description: 'Event image scaling can be: 1 - fit, 2 - crop',
      },
    },
  },
  multiImageTopMargin: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.marginTop,
      defaultValue: {
        type: 'static',
        value: 0,
      },
      ai: {
        description: 'Event image top margin in pixels',
      },
    },
  },
  multiImageBottomMargin: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.marginBottom,
      defaultValue: {
        type: 'static',
        value: 0,
      },
      ai: {
        description: 'Event image bottom margin in pixels',
      },
    },
  },
  multiImageLeftMargin: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.marginLeft,
      defaultValue: {
        type: 'static',
        value: 0,
      },
      ai: {
        description: 'Event image left margin in pixels',
      },
    },
  },
  multiImageRightMargin: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.marginRight,
      defaultValue: {
        type: 'static',
        value: 0,
      },
      ai: {
        description: 'Event image right margin in pixels',
      },
    },
  },
  listLayout: {
    type: StyleParamType.Number,
    getDefaultValue: () => LIST_LAYOUT.NEW_GRID,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: LIST_LAYOUT.NEW_GRID,
      },
      ai: {
        description:
          'List layout can be: 1 - list, 2 - grid, 3 - new grid, 4 - side by side, 5 - calendar, 6 - on image',
      },
    },
  },
  listLayoutType: {
    type: StyleParamType.Number,
    getDefaultValue: () => LIST_LAYOUT_TYPE.STRIPS,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: LIST_LAYOUT_TYPE.STRIPS,
      },
      ai: {
        description: 'List layout type can be: 1 - strips, 2 - cards. Only relevant for list layout - 1.',
      },
    },
  },
  mobileListLayout: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => {
      if (getStyleParamValue(widgetStyles.listLayout) === LIST_LAYOUT.ON_IMAGE) {
        return MOBILE_LIST_LAYOUT.ON_IMAGE
      }

      return MOBILE_LIST_LAYOUT.FULL
    },
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: MOBILE_LIST_LAYOUT.FULL,
      },
      ai: {
        description: 'This style is deprecated. Use mobileWidgetLayoutNew instead.',
      },
    },
  },
  listShowImage: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
      ai: {
        description: 'Controls visibility of the event images.',
      },
    },
  },
  mobileWidgetLayout: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => {
      const mobileListLayout = getStyleParamValue(widgetStyles.mobileListLayout)

      return mobileListLayout === MOBILE_LIST_LAYOUT.COMPACT ||
        getStyleParamValue(widgetStyles.listLayout) === LIST_LAYOUT.LIST
        ? MOBILE_WIDGET_LAYOUT.LIST
        : mobileListLayout === MOBILE_LIST_LAYOUT.ON_IMAGE
        ? MOBILE_WIDGET_LAYOUT.ON_IMAGE
        : MOBILE_WIDGET_LAYOUT.GRID
    },
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: MOBILE_WIDGET_LAYOUT.LIST,
      },
      ai: {
        description: 'This style is deprecated. Use mobileWidgetLayoutNew instead.',
      },
    },
  },
  mobileListLayoutType: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) =>
      getStyleParamValue(widgetStyles.mobileListLayout) === MOBILE_LIST_LAYOUT.COMPACT
        ? MOBILE_LIST_LAYOUT_TYPE.STRIPS
        : getStyleParamValue(widgetStyles.listLayoutType) === LIST_LAYOUT_TYPE.CARDS
        ? MOBILE_LIST_LAYOUT_TYPE.CARDS
        : MOBILE_LIST_LAYOUT_TYPE.FULL,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: MOBILE_LIST_LAYOUT_TYPE.CARDS,
      },
      ai: {
        description: 'This style is deprecated. Use mobileWidgetListLayoutType instead.',
      },
    },
  },
  widgetType: {
    type: StyleParamType.Number,
    getDefaultValue: () => WIDGET_TYPE.LIST,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: WIDGET_TYPE.LIST,
      },
      ai: {
        description:
          'Widget type can be: 2 - list for displaying multiple events, 3 - featured for displaying a single event',
      },
    },
  },
  listTopMargin: {
    type: StyleParamType.Number,
    getDefaultValue: getDefaultListMargin,
    metadata: {
      type: StyleType.marginTop,
      defaultValue: {
        type: 'static',
        value: 20,
      },
    },
  },
  listBottomMargin: {
    type: StyleParamType.Number,
    getDefaultValue: getDefaultListMargin,
    metadata: {
      type: StyleType.marginBottom,
      defaultValue: {
        type: 'static',
        value: 20,
      },
    },
  },
  listLeftMargin: {
    type: StyleParamType.Number,
    getDefaultValue: getDefaultListMargin,
    metadata: {
      type: StyleType.marginLeft,
      defaultValue: {
        type: 'static',
        value: 20,
      },
    },
  },
  listRightMargin: {
    type: StyleParamType.Number,
    getDefaultValue: getDefaultListMargin,
    metadata: {
      type: StyleType.marginRight,
      defaultValue: {
        type: 'static',
        value: 20,
      },
    },
  },
  listTitleFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params => getWidgetFontDefault({params, widgetText: WidgetText.LIST_TITLE, map: paramsMap}),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Page-title',
        size: 36,
      },
      mobileDefaultValue: {
        type: 'static',
        preset: 'Page-title',
        size: 28,
      },
      ai: {
        description: 'Font for the main list title',
      },
    },
  },
  eventTitleColorV2: {
    type: StyleParamType.Color,
    getDefaultValue: params => getWidgetFontColorDefault({params, widgetText: WidgetText.TITLE, map: paramsMap}),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  eventDateColorV2: {
    type: StyleParamType.Color,
    getDefaultValue: params => getWidgetFontColorDefault({params, widgetText: WidgetText.DATE, map: paramsMap}),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  eventLocationColorV2: {
    type: StyleParamType.Color,
    getDefaultValue: params => getWidgetFontColorDefault({params, widgetText: WidgetText.LOCATION, map: paramsMap}),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  eventDescriptionColorV2: {
    type: StyleParamType.Color,
    getDefaultValue: params => getWidgetFontColorDefault({params, widgetText: WidgetText.DESCRIPTION, map: paramsMap}),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  linkColorV2: {
    type: StyleParamType.Color,
    getDefaultValue: params => getWidgetFontColorDefault({params, widgetText: WidgetText.LINK, map: paramsMap}),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  shareIconsColorV2: {
    type: StyleParamType.Color,
    getDefaultValue: params => getSocialShareDefault(params, deprecatedStyles),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  eventTitleFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params => getWidgetFontDefault({params, widgetText: WidgetText.TITLE, map: paramsMap}),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 26,
      },
      mobileDefaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 20,
      },
    },
  },
  eventDateFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params => getWidgetFontDefault({params, widgetText: WidgetText.DATE, map: paramsMap}),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 16,
      },
    },
  },
  eventLocationFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params => getWidgetFontDefault({params, widgetText: WidgetText.LOCATION, map: paramsMap}),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 16,
      },
    },
  },
  eventDescriptionFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params => getWidgetFontDefault({params, widgetText: WidgetText.DESCRIPTION, map: paramsMap}),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 16,
      },
    },
  },
  linkFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params => getWidgetFontDefault({params, widgetText: WidgetText.LINK, map: paramsMap}),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  listFullButtonFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getWidgetButtonDefaultFont({
        params,
        fontParam: deprecatedStyles.listFullButtonFont,
        mobileSizeParam: deprecatedStyles.listButtonFontSizeMobile,
        mobileCompactSizeParam: deprecatedStyles.listButtonFontSizeCompactMobile,
      }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 16,
      },
      ai: {
        description: 'Font for filled buttons',
      },
    },
  },
  listHollowButtonFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getWidgetButtonDefaultFont({
        params,
        fontParam: deprecatedStyles.listHollowButtonFont,
        mobileSizeParam: deprecatedStyles.listButtonFontSizeMobile,
        mobileCompactSizeParam: deprecatedStyles.listButtonFontSizeCompactMobile,
      }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 16,
      },
      ai: {
        description: 'Font for hollow buttons',
      },
    },
  },
  calendarCellEventNameFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 14,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  calendarMainActiveColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  listGeneralTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  listButtonStyle: {
    type: StyleParamType.Number,
    getDefaultValue: () => BUTTONS_STYLE.FULL,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: BUTTONS_STYLE.FULL,
      },
      ai: {
        description: 'Button style can be: 1 - full, 2 - hollow, 3 - full rounded, 4 - hollow rounded',
      },
    },
  },
  listButtonBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 1),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
      ai: {
        description: 'Border color for the hollow buttons',
      },
    },
  },
  listButtonBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 1),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
      ai: {
        description: 'Background color for the full buttons',
      },
    },
  },
  calendarDetailsTitleTextSize: {
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
    metadata: {
      type: StyleType.fontSize,
      defaultValue: {
        type: 'static',
        value: 16,
      },
    },
  },
  calendarCellEventNameColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  calendarDetailsDateLocationTextSize: {
    type: StyleParamType.Number,
    getDefaultValue: () => 14,
    metadata: {
      type: StyleType.fontSize,
      defaultValue: {
        type: 'static',
        value: 14,
      },
    },
  },
  calendarDetailsDescriptionTextSize: {
    type: StyleParamType.Number,
    getDefaultValue: () => 14,
    metadata: {
      type: StyleType.fontSize,
      defaultValue: {
        type: 'static',
        value: 14,
      },
    },
  },
  listHollowButtonFontColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  listFullButtonFontColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
    },
  },
  listButtonBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 1,
      },
      ai: {
        description: 'Border width for the hollow buttons',
      },
    },
  },
  listRoundedButtonBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 100,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 100,
      },
      ai: {
        description: 'Border radius for the rounded buttons',
      },
    },
  },
  listButtonBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  listButtonHoverColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => {
      const style = getStyleParamValue(widgetStyles.listButtonStyle)

      return [BUTTONS_STYLE.HOLLOW, BUTTONS_STYLE.HOLLOW_ROUNDED].includes(style)
        ? getStyleParamValue(widgetStyles.listButtonBorderColor)
        : getStyleParamValue(widgetStyles.listButtonBackgroundColor)
    },
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
      ai: {
        description:
          'Hover color for the buttons. For hollow buttons it is the border color, for full buttons it is the background color.',
      },
    },
  },
  todayButtonStyle: {
    type: StyleParamType.Number,
    getDefaultValue: () => BUTTONS_STYLE.HOLLOW,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: BUTTONS_STYLE.HOLLOW,
      },
      ai: {
        description: 'Today button style can be: 1 - full, 2 - hollow, 3 - full rounded, 4 - hollow rounded',
      },
    },
  },
  todayButtonBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 1),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  todayButtonBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 1),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  calendarCellBackground: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
    },
  },
  calendarCellBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 1,
      },
    },
  },
  soldOutRibbonFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 14,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  rsvpClosedRibbonFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 14,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  joinWaitlistRibbonFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 14,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  membershipRibbonFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 14,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  recurringRibbonFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 14,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  soldOutRibbonTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: () => customColor('#FFFFFF'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: '#FFFFFF', // TODO: check if works
      },
    },
  },
  rsvpClosedRibbonTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: () => customColor('#FFFFFF'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: '#FFFFFF', // TODO: check if works
      },
    },
  },
  joinWaitlistRibbonTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: () => customColor('#FFFFFF'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: '#FFFFFF', // TODO: check if works
      },
    },
  },
  membershipRibbonTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: getDefaultRibbonColor,
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  recurringRibbonTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: getDefaultRibbonColor,
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  soldOutRibbonBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: () => customColor('#F64D43'),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'static',
        preset: '#F64D43', // TODO: check if it works with custom color
      },
    },
  },
  rsvpClosedRibbonBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: () => customColor('#F64D43'),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'static',
        preset: '#F64D43', // TODO: check if it works with custom color
      },
    },
  },
  joinWaitlistRibbonBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: () => customColor('#F64D43'),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'static',
        preset: '#F64D43', // TODO: check if it works with custom color
      },
    },
  },
  membershipRibbonBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: getDefaultRibbonColor,
    metadata: {
      type: StyleType.borderColor,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  recurringRibbonBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: getDefaultRibbonColor,
    metadata: {
      type: StyleType.borderColor,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  calendarListTextSize: {
    type: StyleParamType.Number,
    getDefaultValue: () => 14,
    metadata: {
      type: StyleType.fontSize,
      defaultValue: {
        type: 'static',
        value: 14,
      },
    },
  },
  firstPriorityEventBadgeFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 14,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  secondPriorityEventBadgeFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 14,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  thirdPriorityEventBadgeFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 14,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  firstPriorityEventBadgeColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
    },
  },
  secondPriorityEventBadgeColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
    },
  },
  thirdPriorityEventBadgeColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
    },
  },
  firstPriorityEventBadgeBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  secondPriorityEventBadgeBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  thirdPriorityEventBadgeBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  firstPriorityEventBadgeBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  secondPriorityEventBadgeBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  thirdPriorityEventBadgeBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  firstPriorityEventBadgeBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  secondPriorityEventBadgeBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  thirdPriorityEventBadgeBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  firstPriorityEventBadgeTopLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderTopLeftRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  firstPriorityEventBadgeTopRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderTopRightRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  firstPriorityEventBadgeBottomLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderBottomLeftRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  firstPriorityEventBadgeBottomRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderBottomRightRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  secondPriorityEventBadgeTopLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderTopLeftRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  secondPriorityEventBadgeTopRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderTopRightRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  secondPriorityEventBadgeBottomLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderBottomLeftRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  secondPriorityEventBadgeBottomRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderBottomRightRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  thirdPriorityEventBadgeTopLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderTopLeftRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  thirdPriorityEventBadgeTopRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderTopRightRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  thirdPriorityEventBadgeBottomLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderBottomLeftRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  thirdPriorityEventBadgeBottomRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderBottomRightRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  multiImageOpacity: {
    type: StyleParamType.Number,
    getDefaultValue: () => undefined,
  },
  multiImagePosition: {
    type: StyleParamType.Number,
    getDefaultValue: () => IMAGE_ALIGNMENT.CENTER,
    metadata: {
      type: StyleType.numberEnum,
      defaultValue: {
        type: 'static',
        value: IMAGE_ALIGNMENT.CENTER,
      },
      ai: {
        description:
          'This setting is for the event image focal point. It can be: 1 - top left, 2 - top center, 3 - top right, 4 - center left, 5 - center, 6 - center right, 7 - bottom left, 8 - bottom center, 9 - bottom right',
      },
    },
  },
  multiImageBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  multiImageTopLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderTopLeftRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  multiImageTopRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderTopRightRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  multiImageBottomLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderBottomLeftRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  multiImageBottomRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderBottomRightRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  multiImageBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: () => undefined,
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
      ai: {
        description: 'Background color of the event image container.',
      },
    },
  },
  multiImageBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.2),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: {...wixColor(CssColor.WstParagraph2Color), opacity: 0.2},
    },
  },
  mobileWidgetLayoutNew: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) =>
      getStyleParamValue(widgetStyles.listLayout) === LIST_LAYOUT.CALENDAR
        ? MOBILE_WIDGET_LAYOUT.LIST
        : getStyleParamValue(widgetStyles.mobileWidgetLayout),
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'ref',
        ref: 'mobileWidgetLayout',
      },
      ai: {
        description: 'Mobile widget layout can be: 1 - grid, 2 - list, 3 - on image, 4 - calendar',
      },
    },
  },
  mobileWidgetListLayoutType: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) =>
      getStyleParamValue(widgetStyles.listLayout) === LIST_LAYOUT.CALENDAR
        ? MOBILE_LIST_LAYOUT_TYPE.DAILY
        : getStyleParamValue(widgetStyles.mobileListLayoutType),
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'ref',
        ref: 'mobileListLayoutType',
      },
      ai: {
        description:
          'Mobile list layout type can be: 1 - strips, 2 - cards, 3 - full, 4 - daily. Only relevant when mobile widget layout is list - 2.',
      },
    },
  },
  eventBadgeLayout: {
    type: StyleParamType.Number,
    getDefaultValue: ({isMobile, getStyleParamValue}) => {
      const layout = getStyleParamValue(widgetStyles.listLayout)
      const mobileLayout = getStyleParamValue(widgetStyles.mobileWidgetLayoutNew)
      const mobileWidgetListLayoutType = getStyleParamValue(widgetStyles.mobileWidgetListLayoutType)
      const mobileCompactLayout =
        mobileLayout === MOBILE_WIDGET_LAYOUT.LIST && mobileWidgetListLayoutType !== MOBILE_LIST_LAYOUT_TYPE.FULL
      const eventInfo = isMobile
        ? mobileLayout === MOBILE_WIDGET_LAYOUT.ON_IMAGE || mobileCompactLayout
        : [LIST_LAYOUT.LIST, LIST_LAYOUT.ON_IMAGE].includes(layout)

      return eventInfo ? EVENT_BADGE_LAYOUT.EVENT_INFO : EVENT_BADGE_LAYOUT.ON_IMAGE
    },
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: EVENT_BADGE_LAYOUT.ON_IMAGE,
      },
      ai: {
        description: 'Event badge layout can be: 1 - on image, 2 - on event info card',
      },
    },
  },
  eventBadgeVerticalAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => VERTICAL_ALIGNMENT.TOP,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: VERTICAL_ALIGNMENT.TOP,
      },
    },
  },
  eventBadgeHorizontalAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => ALIGNMENT.LEFT,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: ALIGNMENT.LEFT,
      },
    },
  },
  eventBadgeStretched: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
    },
  },
  calendarDayNumberFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 24,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 24,
      },
    },
  },
  calendarRsvpButtonStyle: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listButtonStyle),
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'ref',
        ref: 'listButtonStyle',
      },
    },
  },
  calendarHollowRsvpButtonBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listButtonBorderColor),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: {
        type: 'ref',
        ref: 'listButtonBorderColor',
      },
    },
  },
  calendarFullRsvpButtonBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listButtonBackgroundColor),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'ref',
        ref: 'listButtonBackgroundColor',
      },
    },
  },
}) as {[P in keyof IWidgetStyles]: IStyleParam<IWidgetStyles[P]>}

const getDefaultListItemVerticalPadding: IStyleParam['getDefaultValue'] = ({isMobile, getStyleParamValue}) => {
  const layout = getStyleParamValue(widgetStyles.listLayout)
  const mobileLayout = getStyleParamValue(widgetStyles.mobileWidgetLayoutNew)
  const mobileListLayoutType = getStyleParamValue(widgetStyles.mobileWidgetListLayoutType)
  const featuredWidget = getStyleParamValue(widgetStyles.widgetType) === WIDGET_TYPE.FEATURED
  const listPadding = getStyleParamValue(deprecatedStyles.listStripWidth) + 10

  const onImageFeatured =
    featuredWidget && (isMobile ? mobileLayout === MOBILE_WIDGET_LAYOUT.ON_IMAGE : layout === LIST_LAYOUT.ON_IMAGE)

  if (onImageFeatured) {
    return isMobile ? 120 : 150
  }

  if (isMobile) {
    return mobileLayout === MOBILE_WIDGET_LAYOUT.LIST && mobileListLayoutType !== MOBILE_LIST_LAYOUT_TYPE.DAILY
      ? listPadding
      : 20
  } else {
    return layout === LIST_LAYOUT.SIDE_BY_SIDE ? 60 : layout === LIST_LAYOUT.LIST ? listPadding : 32
  }
}

const getDefaultListItemHorizontalPadding: IStyleParam['getDefaultValue'] = ({isMobile, getStyleParamValue}) => {
  const layout = getStyleParamValue(widgetStyles.listLayout)
  const mobileListLayoutType = getStyleParamValue(widgetStyles.mobileWidgetListLayoutType)

  if (isMobile) {
    return getStyleParamValue(widgetStyles.mobileWidgetLayoutNew) === MOBILE_WIDGET_LAYOUT.LIST &&
      mobileListLayoutType !== MOBILE_LIST_LAYOUT_TYPE.DAILY
      ? mobileListLayoutType === MOBILE_LIST_LAYOUT_TYPE.CARDS
        ? 30
        : 0
      : 20
  } else {
    return layout === LIST_LAYOUT.SIDE_BY_SIDE
      ? 60
      : layout === LIST_LAYOUT.LIST
      ? getStyleParamValue(widgetStyles.listLayoutType) === LIST_LAYOUT_TYPE.STRIPS
        ? 0
        : 30
      : 32
  }
}

const styleParams: Record<keyof IStyles, IStyleParam> = {
  ...widgetStyles,
  ...deprecatedStyles,
  onImageCardHeightBehavior: {
    type: StyleParamType.Number,
    getDefaultValue() {
      return ON_IMAGE_CARD_HEIGHT_BEHAVIOR.FIXED
    },
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: ON_IMAGE_CARD_HEIGHT_BEHAVIOR.FIXED,
      },
      ai: {
        description:
          'Controls the height of on image rows. Can be: 0 - responsive, 1 - fixed to same height as the tallest row',
      },
    },
  },
  borderWidth: {
    type: StyleParamType.Number,
    getDefaultValue() {
      return 0
    },
  },
  todayButtonBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue() {
      return 1
    },
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 1,
      },
    },
  },
  todayButtonBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue() {
      return 0
    },
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue() {
      return 0
    },
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  buttonsBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue() {
      return 1
    },
  },
  todayRoundedButtonBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue() {
      return 100
    },
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 100,
      },
    },
  },
  widgetLayout: {
    type: StyleParamType.Number,
    getDefaultValue: () => WIDGET_LAYOUT.FULL,
  },
  alignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => 2,
  },
  contentAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => 2,
  },
  listAlignment: {
    type: StyleParamType.Number,
    inheritDesktop: false,
    getDefaultValue: ({isMobile, getStyleParamValue}) => {
      const mobileOnImage = getStyleParamValue(widgetStyles.mobileWidgetLayoutNew) === MOBILE_WIDGET_LAYOUT.ON_IMAGE

      return isMobile && !mobileOnImage ? LIST_ALIGNMENT.LEFT : LIST_ALIGNMENT.CENTER
    },
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: LIST_ALIGNMENT.CENTER,
      },
      ai: {
        description: 'List text horizontal alignment can be: 1 - left, 2 - center, 3 - right',
      },
    },
  },
  imagePosition: {
    type: StyleParamType.Number,
    getDefaultValue: () => undefined,
  },
  verticalImagePosition: {
    type: StyleParamType.Number,
    getDefaultValue: () => undefined,
  },
  imageGridPosition: {
    type: StyleParamType.Number,
    getDefaultValue: () => undefined,
  },
  imageScaling: {
    type: StyleParamType.Number,
    getDefaultValue: () => IMAGE_SCALING.CROP,
  },
  listImageSize: {
    type: StyleParamType.Number,
    getDefaultValue: () => LIST_IMAGE_SIZE.SMALL,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: LIST_IMAGE_SIZE.SMALL,
      },
      ai: {
        description: 'List image size can be: 1 - small, 2 - medium, 3 - large. Only relevant for list layout - 1.',
      },
    },
  },
  imageRatio: {
    type: StyleParamType.Number,
    getDefaultValue: () => IMAGE_RATIO['1:1'],
  },
  listImageLayout: {
    type: StyleParamType.Number,
    getDefaultValue: ({isRTL}) => (isRTL ? LIST_IMAGE_LAYOUT.RIGHT : LIST_IMAGE_LAYOUT.LEFT),
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: LIST_IMAGE_LAYOUT.LEFT,
      },
      ai: {
        description:
          'Controls the position of the event image in side by side list layout. Can be: 1 - left, 2 - mixed, 3 - right',
      },
    },
  },
  locationAndDateFormat: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  cardsPerRow: {
    type: StyleParamType.Number,
    getDefaultValue: () => 3,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 3,
      },
      ai: {
        description: 'Controls how many events to show in one row, Maximum is 5.',
      },
    },
  },
  buttonsStyle: {
    type: StyleParamType.Number,
    getDefaultValue: () => BUTTONS_STYLE.FULL,
  },
  buttonsBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  roundedButtonsBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 100,
  },
  buttonHeight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 44,
  },
  oneButtonWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 140,
  },
  verticalDividerWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  verticalDividerHeight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 94,
  },
  horizontalDividerWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 20,
  },
  horizontalDividerHeight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  compactHorizontalDividerWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 36,
  },
  compactHorizontalDividerHeight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  countdownMarginBottom: {
    type: StyleParamType.Number,
    getDefaultValue: () => 30,
  },
  titleMarginBottom: {
    type: StyleParamType.Number,
    getDefaultValue: () => 36,
  },
  descriptionMarginBottom: {
    type: StyleParamType.Number,
    getDefaultValue: () => 42,
  },
  dateMarginBottom: {
    type: StyleParamType.Number,
    getDefaultValue: () => 42,
  },
  locationMarginBottom: {
    type: StyleParamType.Number,
    getDefaultValue: () => 54,
  },
  dateAndLocationMarginBottom: {
    type: StyleParamType.Number,
    getDefaultValue: () => 54,
  },
  rsvpMarginBottom: {
    type: StyleParamType.Number,
    getDefaultValue: () => 30,
  },
  imageWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 50,
  },
  imageOpacity: {
    type: StyleParamType.Number,
    getDefaultValue: () => 70,
  },
  listItemTopPadding: {
    type: StyleParamType.Number,
    getDefaultValue: getDefaultListItemVerticalPadding,
    metadata: {
      type: StyleType.paddingTop,
      defaultValue: {
        type: 'static',
        value: 32,
      },
    },
  },
  listItemBottomPadding: {
    type: StyleParamType.Number,
    getDefaultValue: getDefaultListItemVerticalPadding,
    metadata: {
      type: StyleType.paddingBottom,
      defaultValue: {
        type: 'static',
        value: 32,
      },
    },
  },
  listItemLeftPadding: {
    type: StyleParamType.Number,
    getDefaultValue: getDefaultListItemHorizontalPadding,
    metadata: {
      type: StyleType.paddingLeft,
      defaultValue: {
        type: 'static',
        value: 32,
      },
    },
  },
  listItemRightPadding: {
    type: StyleParamType.Number,
    getDefaultValue: getDefaultListItemHorizontalPadding,
    metadata: {
      type: StyleType.paddingRight,
      defaultValue: {
        type: 'static',
        value: 32,
      },
    },
  },
  gapBetweenCards: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => {
      const layout = getStyleParamValue(widgetStyles.listLayout)

      return layout === LIST_LAYOUT.NEW_GRID || layout === LIST_LAYOUT.GRID || layout === LIST_LAYOUT.ON_IMAGE
        ? getStyleParamValue(deprecatedStyles.cardMargins)
        : layout === LIST_LAYOUT.SIDE_BY_SIDE
        ? getStyleParamValue(deprecatedStyles.sideBySideLayoutMargins)
        : 30
    },
    metadata: {
      type: StyleType.gap,
      defaultValue: {
        type: 'static',
        value: 30,
      },
      ai: {
        description: 'Controls the gap between list items.',
      },
    },
  },
  listImageOpacity: {
    type: StyleParamType.Number,
    getDefaultValue: () => 100,
  },
  calendarImageOpacity: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.multiImageOpacity),
  },
  calendarImagePosition: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.multiImagePosition),
    metadata: {
      type: StyleType.numberEnum,
      defaultValue: {
        type: 'ref',
        ref: 'multiImagePosition',
      },
    },
  },
  calendarImageBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.multiImageBorderWidth),
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'ref',
        ref: 'multiImageBorderWidth',
      },
    },
  },
  calendarImageTopLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.multiImageTopLeftBorderRadius),
    metadata: {
      type: StyleType.borderTopLeftRadius,
      defaultValue: {
        type: 'ref',
        ref: 'multiImageTopLeftBorderRadius',
      },
    },
  },
  calendarImageTopRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.multiImageTopRightBorderRadius),
    metadata: {
      type: StyleType.borderTopRightRadius,
      defaultValue: {
        type: 'ref',
        ref: 'multiImageTopRightBorderRadius',
      },
    },
  },
  calendarImageBottomLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.multiImageBottomLeftBorderRadius),
    metadata: {
      type: StyleType.borderBottomLeftRadius,
      defaultValue: {
        type: 'ref',
        ref: 'multiImageBottomLeftBorderRadius',
      },
    },
  },
  calendarImageBottomRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.multiImageBottomRightBorderRadius),
    metadata: {
      type: StyleType.borderBottomRightRadius,
      defaultValue: {
        type: 'ref',
        ref: 'multiImageBottomRightBorderRadius',
      },
    },
  },
  listImageWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 50,
    metadata: {
      type: StyleType.width,
      defaultValue: {
        type: 'static',
        value: 50,
      },
      ai: {
        description: 'Controls the width of the event image in side by side layout. Maximum is 95%',
      },
    },
  },
  calendarWeekStartDay: {
    type: StyleParamType.Number,
    getDefaultValue: () => DEFAULT_WEEK_START,
    metadata: {
      type: StyleType.numberEnum,
      defaultValue: {
        type: 'static',
        value: DEFAULT_WEEK_START,
      },
      ai: {
        description:
          'Calendar week start day can be: 0 - Sunday, 1 - Monday, 2 - Tuesday, 3 - Wednesday, 4 - Thursday, 5 - Friday, 6 - Saturday',
      },
    },
  },
  calendarListDividerWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 1,
      },
    },
  },
  recurringFilter: {
    type: StyleParamType.Number,
    getDefaultValue: () => undefined,
  },
  showImage: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  },
  showCountdown: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
  },
  showOfferRibbon: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  showRecurringRibbon: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  showTitle: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  },
  showDescription: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
  },
  showDate: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  },
  showLocation: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  },
  showShareOptions: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  },
  showFullDividers: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  },
  showHorizontalDividers: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  },
  showCompactDividers: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  },
  showLabels: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  },
  showRSVPTitle: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
  },
  showMembers: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
  },
  listShowLoadMore: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
      ai: {
        description: 'Controls visibility of the load more button.',
      },
    },
  },
  listShowMainTitle: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
      ai: {
        description: 'Controls visibility of the main list title.',
      },
    },
  },
  listShowDescription: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
      ai: {
        description: 'Controls visibility of the event description.',
      },
    },
  },
  listShowSocialShare: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
      ai: {
        description: 'Controls visibility of the event social share options.',
      },
    },
  },
  listShowAdditionalInfo: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
      ai: {
        description:
          'Indicates if additional event details should be displayed to the user, revealing this information when triggered (e.g., on click).',
      },
    },
  },
  showSoldOutRibbon: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => undefined,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
    },
  },
  showRibbon: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
  },
  showRsvpClosedRibbon: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => undefined,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
    },
  },
  showJoinWaitlistRibbon: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => undefined,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
    },
  },
  calendarBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-2'),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: wixColor(CssColor.WstSecondaryBackgroundColor),
    },
  },
  calendarMonthColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  calendarMonthFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 18,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 18,
      },
    },
  },
  calendarWeekdaysColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  calendarWeekdaysFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 14,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  calendarDayNumberColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  calendarDayNumberFontNew: {
    type: StyleParamType.Font,
    getDefaultValue: ({isMobile, getStyleParamValue}) => {
      const font = getStyleParamValue(widgetStyles.calendarDayNumberFont)

      return isMobile ? {...font, size: 16} : font
    },
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'calendarDayNumberFont',
      },
    },
  },
  calendarCellEventTimeColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-4'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph3Color),
    },
  },
  calendarCellEventNameFontNew: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarCellEventNameFont),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'calendarCellEventNameFont',
      },
    },
  },
  calendarCellEventTimeFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarCellEventNameFont),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'calendarCellEventNameFont',
      },
    },
  },
  calendarCellMoreEventsFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => {
      const font = getStyleParamValue(widgetStyles.calendarCellEventNameFont)

      return {...font, size: 14}
    },
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'calendarCellEventNameFont',
      },
    },
  },
  calendarCellMoreEventsColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarMainActiveColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'calendarMainActiveColor',
      },
    },
  },
  calendarCellTodayColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => {
      const color = getStyleParamValue(widgetStyles.calendarMainActiveColor)

      return {...color, value: colorToRgba(color.value, 0.2), opacity: 0.2}
    },
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'calendarMainActiveColor',
      },
    },
  },
  calendarCellWeekendBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.04),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {...wixColor(CssColor.WstParagraph2Color), opacity: 0.04},
    },
  },
  calendarEventPopupEventNameFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => {
      const font = getStyleParamValue(widgetStyles.calendarCellEventNameFont)
      const size = getStyleParamValue(widgetStyles.calendarDetailsTitleTextSize)

      return {...font, size}
    },
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 16,
      },
    },
  },
  calendarEventPopupEventNameColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarCellEventNameColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'calendarCellEventNameColor',
      },
    },
  },
  calendarEventPopupFullDateFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => {
      const font = getStyleParamValue(widgetStyles.calendarCellEventNameFont)
      const size = getStyleParamValue(widgetStyles.calendarDetailsDateLocationTextSize)

      return {...font, size}
    },
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  calendarEventPopupFullDateColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarCellEventNameColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'calendarCellEventNameColor',
      },
    },
  },
  calendarEventPopupLocationFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => {
      const font = getStyleParamValue(widgetStyles.calendarCellEventNameFont)
      const size = getStyleParamValue(widgetStyles.calendarDetailsDateLocationTextSize)

      return {...font, size}
    },
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  calendarEventPopupLocationColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarCellEventNameColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'calendarCellEventNameColor',
      },
    },
  },
  calendarEventPopupDescriptionFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => {
      const font = getStyleParamValue(widgetStyles.calendarCellEventNameFont)
      const size = getStyleParamValue(styleParams.calendarDetailsDescriptionTextSize)

      return {...font, size}
    },
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  calendarEventPopupDescriptionColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarCellEventNameColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'calendarCellEventNameColor',
      },
    },
  },
  calendarEventPopupMembersFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => {
      const font = getStyleParamValue(widgetStyles.calendarCellEventNameFont)

      return {...font, size: 14}
    },
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  calendarEventPopupMembersColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarCellEventNameColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'calendarCellEventNameColor',
      },
    },
  },
  calendarEventPopupShareIconsColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarCellEventNameColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'calendarCellEventNameColor',
      },
    },
  },
  calendarCellBackgroundNew: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarCellBackground),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'ref',
        ref: 'calendarCellBackground',
      },
    },
  },
  calendarEventPopupBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarCellBackground),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'ref',
        ref: 'calendarCellBackground',
      },
    },
  },
  calendarCellBorderWidthNew: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarCellBorderWidth),
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'ref',
        ref: 'calendarCellBorderWidth',
      },
    },
  },
  calendarEventPopupBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarCellBorderWidth),
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'ref',
        ref: 'calendarCellBorderWidth',
      },
    },
  },
  calendarEventPopupBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarMainActiveColor),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: {
        type: 'ref',
        ref: 'calendarMainActiveColor',
      },
    },
  },
  calendarEventPopupTopLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderTopLeftRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarEventPopupTopRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderTopRightRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarEventPopupBottomLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderBottomLeftRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarEventPopupBottomRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderBottomRightRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarEventPopupBoxShadowVisible: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
    },
  },
  calendarEventPopupBoxShadowDistance: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarEventPopupBoxShadowAngle: {
    type: StyleParamType.Number,
    getDefaultValue: () => 135,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 135,
      },
    },
  },
  calendarEventPopupBoxShadowBlur: {
    type: StyleParamType.Number,
    getDefaultValue: () => 25,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 25,
      },
    },
  },
  calendarEventPopupBoxShadowColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.12),
    metadata: {
      type: StyleType.color,
      defaultValue: {...wixColor(CssColor.WstParagraph2Color), opacity: 0.12},
    },
  },
  calendarRsvpButtonHoverColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => {
      const style = getStyleParamValue(widgetStyles.calendarRsvpButtonStyle)

      return [BUTTONS_STYLE.HOLLOW, BUTTONS_STYLE.HOLLOW_ROUNDED].includes(style)
        ? getStyleParamValue(widgetStyles.calendarHollowRsvpButtonBorderColor)
        : getStyleParamValue(widgetStyles.calendarFullRsvpButtonBackgroundColor)
    },
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  calendarHollowRsvpButtonFontColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listHollowButtonFontColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'listHollowButtonFontColor',
      },
    },
  },
  calendarFullRsvpButtonFontColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listFullButtonFontColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'listFullButtonFontColor',
      },
    },
  },
  calendarEventListPopupTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarMainActiveColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'calendarMainActiveColor',
      },
    },
  },
  calendarEventListPopupTitleFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => {
      const font = getStyleParamValue(widgetStyles.calendarCellEventNameFont)
      const size = getStyleParamValue(widgetStyles.calendarListTextSize)

      return {...font, size}
    },
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  calendarEventListPopupEventTimeColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-4'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph3Color),
    },
  },
  calendarEventListPopupEventTimeFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => {
      const font = getStyleParamValue(widgetStyles.calendarCellEventNameFont)
      const size = getStyleParamValue(widgetStyles.calendarListTextSize)

      return {...font, size}
    },
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  calendarEventListPopupEventNameColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarCellEventNameColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'calendarCellEventNameColor',
      },
    },
  },
  calendarEventListPopupEventNameFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => {
      const font = getStyleParamValue(widgetStyles.calendarCellEventNameFont)
      const size = getStyleParamValue(widgetStyles.calendarListTextSize)

      return {...font, size}
    },
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  calendarEventListPopupDividerColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarCellEventNameColor),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: {
        type: 'ref',
        ref: 'calendarCellEventNameColor',
      },
    },
  },
  calendarEventListPopupBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarCellBackground),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'ref',
        ref: 'calendarCellBackground',
      },
    },
  },
  calendarCellHoverColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => {
      const styleParamValue = getStyleParamValue(widgetStyles.calendarMainActiveColor)

      return {...styleParamValue, value: colorToRgba(styleParamValue.value, 0.2), opacity: 0.2}
    },
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'ref',
        ref: 'calendarMainActiveColor',
      },
    },
  },
  calendarEventListPopupBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarCellBorderWidth),
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'ref',
        ref: 'calendarCellBorderWidth',
      },
    },
  },
  calendarEventListPopupBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarMainActiveColor),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: {
        type: 'ref',
        ref: 'calendarMainActiveColor',
      },
    },
  },
  calendarEventListPopupTopLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderTopLeftRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarEventListPopupTopRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderTopRightRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarEventListPopupBottomLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderBottomLeftRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarEventListPopupBottomRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderBottomRightRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarEventListPopupBoxShadowVisible: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
    },
  },
  calendarEventListPopupBoxShadowDistance: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarEventListPopupBoxShadowAngle: {
    type: StyleParamType.Number,
    getDefaultValue: () => 135,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 135,
      },
    },
  },
  calendarEventListPopupBoxShadowBlur: {
    type: StyleParamType.Number,
    getDefaultValue: () => 25,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 25,
      },
    },
  },
  calendarEventListPopupBoxShadowColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.12),
    metadata: {
      type: StyleType.color,
      defaultValue: {...wixColor(CssColor.WstParagraph2Color), opacity: 0.12},
    },
  },
  calendarHollowRsvpButtonFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listHollowButtonFontV2),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'listHollowButtonFontV2',
      },
    },
  },
  calendarFullRsvpButtonFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listFullButtonFontV2),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'listFullButtonFontV2',
      },
    },
  },
  calendarRsvpButtonBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listButtonBorderWidth),
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'ref',
        ref: 'listButtonBorderWidth',
      },
    },
  },
  calendarRoundedRsvpButtonBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listRoundedButtonBorderRadius),
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'ref',
        ref: 'listRoundedButtonBorderRadius',
      },
    },
  },
  calendarRsvpButtonBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listButtonBorderRadius),
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'ref',
        ref: 'listButtonBorderRadius',
      },
    },
  },
  todayHollowButtonColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  todayHollowButtonFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 14,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  todayButtonColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
    },
  },
  todayButtonFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 14,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  ribbonTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: () => customColor('#FFFFFF'),
  },
  ribbonFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 14,
    }),
  },
  onImageHollowButtonsFontColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  hollowButtonsFontColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
  },
  onImageFullButtonsFontColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  fullButtonsFontColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  hollowButtonsFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 16,
    }),
  },
  fullButtonsFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 16,
    }),
  },
  countdownFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 20,
    }),
  },
  countdownColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  onImageCountdownColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  titleFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Page-title', {
      size: 46,
    }),
  },
  titleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  onImageTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  descriptionFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 15,
    }),
  },
  onImageDescriptionColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  descriptionColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  labelsFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 16,
    }),
  },
  onImageLabelsColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  labelsColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  compactTextsFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 24,
    }),
  },
  textsFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 15,
    }),
  },
  onImageTextsColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  textsColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  calendarCellBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-2', 1),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: wixColor(CssColor.WstSecondaryBackgroundColor),
    },
  },
  calendarPastDaysBackground: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-2', 0.1),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {...wixColor(CssColor.WstSecondaryBackgroundColor), opacity: 0.1},
    },
  },
  widgetBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({isMobile, getStyleParamValue}) => {
      const mobileListLayoutType = getStyleParamValue(widgetStyles.mobileWidgetListLayoutType)
      const mobileCompact =
        getStyleParamValue(widgetStyles.mobileWidgetLayoutNew) === MOBILE_WIDGET_LAYOUT.LIST &&
        mobileListLayoutType !== MOBILE_LIST_LAYOUT_TYPE.FULL &&
        mobileListLayoutType !== MOBILE_LIST_LAYOUT_TYPE.DAILY

      return getStyleParamValue(widgetStyles.listLayout) === LIST_LAYOUT.LIST
        ? getStyleParamValue(deprecatedStyles.listBackgroundColor)
        : isMobile && mobileCompact
        ? getStyleParamValue(deprecatedStyles.cardBackgroundColor)
        : getStyleParamValue(deprecatedStyles.cardsBackgroundColor)
    },
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
    },
  },
  widgetBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({colors, getStyleParamValue}) =>
      getStyleParamValue(widgetStyles.listLayout) === LIST_LAYOUT.LIST
        ? getStyleParamValue(deprecatedStyles.listBorderColor)
        : wixColorParam('color-2', 1)({colors}),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: wixColor(CssColor.WstSecondaryBackgroundColor),
    },
  },
  widgetBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) =>
      getStyleParamValue(widgetStyles.listLayout) === LIST_LAYOUT.LIST
        ? getStyleParamValue(deprecatedStyles.listBorderWidth)
        : 0,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  listItemBorderAndDividerColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) =>
      getStyleParamValue(widgetStyles.listLayout) === LIST_LAYOUT.LIST
        ? getStyleParamValue(deprecatedStyles.listDividerColor)
        : getStyleParamValue(deprecatedStyles.cardBorderColor),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: wixColor(CssColor.WstSecondaryBackgroundColor),
    },
  },
  listItemBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({colors, getStyleParamValue}) =>
      getStyleParamValue(widgetStyles.listLayout) === LIST_LAYOUT.LIST &&
      getStyleParamValue(widgetStyles.widgetType) !== WIDGET_TYPE.FEATURED
        ? wixColorParam('color-1', 0)({colors})
        : getStyleParamValue(deprecatedStyles.cardBackgroundColor),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
    },
  },
  listItemBorderAndDividerWidth: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) =>
      getStyleParamValue(widgetStyles.listLayout) === LIST_LAYOUT.LIST
        ? getStyleParamValue(deprecatedStyles.listDividerWidth)
        : getStyleParamValue(deprecatedStyles.cardBorderWidth),
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 1,
      },
    },
  },
  todayButtonHoverColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => {
      const style = getStyleParamValue(widgetStyles.todayButtonStyle)

      return [BUTTONS_STYLE.HOLLOW, BUTTONS_STYLE.HOLLOW_ROUNDED].includes(style)
        ? getStyleParamValue(widgetStyles.todayButtonBorderColor)
        : getStyleParamValue(widgetStyles.todayButtonBackgroundColor)
    },
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  listImageBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 1),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  calendarImageBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.multiImageBackgroundColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'multiImageBackgroundColor',
      },
    },
  },
  calendarImageBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.multiImageBorderColor),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: {
        type: 'ref',
        ref: 'multiImageBorderColor',
      },
    },
  },
  ribbonBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: () => customColor('#F64D43'),
  },
  imageBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
  },
  backgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 1),
  },
  borderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-2', 1),
  },
  onImageButtonsBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 1),
  },
  buttonsBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 1),
  },
  onImageButtonsBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 1),
  },
  buttonsBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 1),
  },
  onImageDividerColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 1),
  },
  dividerColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
  },
  calendarBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 0),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
    },
  },
  listLoadMoreContainerBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 1),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  listShowCountdown: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
      ai: {
        description: 'Controls visibility of the countdown until event start, on list items.',
      },
    },
  },
  listCountdownFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 12,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 12,
      },
    },
  },
  listCountdownColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  listCountdownBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
    },
  },
  listCountdownBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.4),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: {...wixColor(CssColor.WstParagraph2Color), opacity: 0.4},
    },
  },
  listCountdownTopLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 30,
    metadata: {
      type: StyleType.borderTopLeftRadius,
      defaultValue: {
        type: 'static',
        value: 30,
      },
    },
  },
  listCountdownTopRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 30,
    metadata: {
      type: StyleType.borderTopRightRadius,
      defaultValue: {
        type: 'static',
        value: 30,
      },
    },
  },
  listCountdownBottomLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 30,
    metadata: {
      type: StyleType.borderBottomLeftRadius,
      defaultValue: {
        type: 'static',
        value: 30,
      },
    },
  },
  listCountdownBottomRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 30,
    metadata: {
      type: StyleType.borderBottomRightRadius,
      defaultValue: {
        type: 'static',
        value: 30,
      },
    },
  },
  itemFixedHeight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 500,
    metadata: {
      type: StyleType.height,
      defaultValue: {
        type: 'static',
        value: 500,
      },
      ai: {
        description: 'Controls the height of the list items. Only relevant when itemHeightType is fixed.',
      },
    },
  },
  itemHeightType: {
    type: StyleParamType.Number,
    getDefaultValue: () => ITEM_HEIGHT_TYPE.DYNAMIC,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: ITEM_HEIGHT_TYPE.DYNAMIC,
      },
      ai: {
        description: 'Item height type can be: 1 - dynamic, 2 - fixed',
      },
    },
  },
  topLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderTopLeftRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
      ai: {
        description: 'Controls the top left border radius of the list items.',
      },
    },
  },
  topRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderTopRightRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
      ai: {
        description: 'Controls the top right border radius of the list items.',
      },
    },
  },
  bottomLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderBottomLeftRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
      ai: {
        description: 'Controls the bottom left border radius of the list items.',
      },
    },
  },
  bottomRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderBottomRightRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
      ai: {
        description: 'Controls the bottom right border radius of the list items.',
      },
    },
  },
  eventBoxShadowVisible: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
      ai: {
        description: 'Controls visibility of the event item box shadow.',
      },
    },
  },
  eventBoxShadowAngle: {
    type: StyleParamType.Number,
    getDefaultValue: () => 135,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 135,
      },
      ai: {
        description: 'Controls the angle of the event item box shadow.',
      },
    },
  },
  eventBoxShadowDistance: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 0,
      },
      ai: {
        description: 'Controls the distance of the event item box shadow.',
      },
    },
  },
  eventBoxShadowBlur: {
    type: StyleParamType.Number,
    getDefaultValue: () => 25,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 25,
      },
      ai: {
        description: 'Controls the blur of the event item box shadow.',
      },
    },
  },
  eventBoxShadowColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.12),
    metadata: {
      type: StyleType.color,
      defaultValue: {...wixColor(CssColor.WstParagraph2Color), opacity: 0.12},
      ai: {
        description: 'Controls the color of the event item box shadow.',
      },
    },
  },
  imageOverlayColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.45),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {...wixColor(CssColor.WstParagraph2Color), opacity: 0.45},
      ai: {
        description: 'Controls the color of the event image overlay in on image layout.',
      },
    },
  },
  categoryMenuColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  categoryMenuDividerColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.3),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: {...wixColor(CssColor.WstParagraph2Color), opacity: 0.3},
    },
  },
  categoryMenuSelectedUnderlineColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  listImageHoverEffect: {
    type: StyleParamType.Number,
    getDefaultValue: () => IMAGE_HOVER_EFFECT.ZOOM_IN,
    metadata: {
      type: StyleType.numberEnum,
      defaultValue: {
        type: 'static',
        value: IMAGE_HOVER_EFFECT.ZOOM_IN,
      },
      ai: {
        description: 'Image hover effect can be: 1 - none, 2 - zoom in',
      },
    },
  },
  listTextVerticalAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue, isMobile}) =>
      !isMobile && [LIST_LAYOUT.SIDE_BY_SIDE, LIST_LAYOUT.LIST].includes(getStyleParamValue(widgetStyles.listLayout))
        ? VERTICAL_ALIGNMENT.CENTER
        : VERTICAL_ALIGNMENT.TOP,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: VERTICAL_ALIGNMENT.CENTER,
      },
      ai: {
        description: 'Text vertical alignment can be: 1 - top, 2 - center, 3 - bottom',
      },
    },
  },
  listShowMembers: {
    type: StyleParamType.Boolean,
    getDefaultValue: ({getStyleParamValue, isMobile}) => {
      const onImage = isMobile
        ? getStyleParamValue(widgetStyles.mobileWidgetLayoutNew) === MOBILE_WIDGET_LAYOUT.ON_IMAGE
        : getStyleParamValue(widgetStyles.listLayout) === LIST_LAYOUT.ON_IMAGE

      return !onImage
    },
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
      ai: {
        description: 'Controls visibility of the event guests.',
      },
    },
  },
  hoveredEventTitleColorV2: {
    type: StyleParamType.Color,
    getDefaultValue: params =>
      getWidgetFontColorDefault({
        params,
        widgetText: WidgetText.TITLE,
        map: paramsMap,
        hover: true,
        defaultParam: widgetStyles.eventTitleColorV2,
      }),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'eventTitleColorV2',
      },
      ai: {
        description: 'Controls the color of the event title when item is hovered or expanded.',
      },
    },
  },
  hoveredEventDateColorV2: {
    type: StyleParamType.Color,
    getDefaultValue: params =>
      getWidgetFontColorDefault({
        params,
        widgetText: WidgetText.DATE,
        map: paramsMap,
        hover: true,
        defaultParam: widgetStyles.eventDateColorV2,
      }),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'eventDateColorV2',
      },
      ai: {
        description: 'Controls the color of the event date when item is hovered or expanded.',
      },
    },
  },
  hoveredEventLocationColorV2: {
    type: StyleParamType.Color,
    getDefaultValue: params =>
      getWidgetFontColorDefault({
        params,
        widgetText: WidgetText.LOCATION,
        map: paramsMap,
        hover: true,
        defaultParam: widgetStyles.eventLocationColorV2,
      }),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'eventLocationColorV2',
      },
      ai: {
        description: 'Controls the color of the event location when item is hovered or expanded.',
      },
    },
  },
  hoveredEventDescriptionColor: {
    type: StyleParamType.Color,
    getDefaultValue: params =>
      getWidgetFontColorDefault({
        params,
        widgetText: WidgetText.DESCRIPTION,
        map: paramsMap,
        hover: true,
        defaultParam: widgetStyles.eventDescriptionColorV2,
      }),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'eventDescriptionColorV2',
      },
      ai: {
        description: 'Controls the font of the event description when item is expanded.',
      },
    },
  },
  hoveredEventTitleFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getWidgetFontDefault({
        params,
        widgetText: WidgetText.TITLE,
        map: paramsMap,
        hover: true,
        defaultParam: widgetStyles.eventTitleFontV2,
      }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'eventTitleFontV2',
      },
      ai: {
        description: 'Controls the font of the event title when item is hovered or expanded.',
      },
    },
  },
  hoveredEventDateFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getWidgetFontDefault({
        params,
        widgetText: WidgetText.DATE,
        map: paramsMap,
        hover: true,
        defaultParam: widgetStyles.eventDateFontV2,
      }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'eventDateFontV2',
      },
      ai: {
        description: 'Controls the font of the event date when item is hovered or expanded.',
      },
    },
  },
  hoveredEventLocationFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getWidgetFontDefault({
        params,
        widgetText: WidgetText.LOCATION,
        map: paramsMap,
        hover: true,
        defaultParam: widgetStyles.eventLocationFontV2,
      }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'eventLocationFontV2',
      },
      ai: {
        description: 'Controls the font of the event location when item is hovered or expanded.',
      },
    },
  },
  hoveredEventDescriptionFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getWidgetFontDefault({
        params,
        widgetText: WidgetText.DESCRIPTION,
        map: paramsMap,
        hover: true,
        defaultParam: widgetStyles.eventDescriptionFontV2,
      }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'eventDescriptionFontV2',
      },
      ai: {
        description: 'Controls the font of the event description when item is expanded.',
      },
    },
  },
  listExtraInfoShowDate: {
    type: StyleParamType.Boolean,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(deprecatedStyles.listShowFullDate),
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
      ai: {
        description: 'Controls visibility of the event date in additional info when item is expanded.',
      },
    },
  },
  listExtraInfoShowLocation: {
    type: StyleParamType.Boolean,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(deprecatedStyles.listShowLocation),
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
      ai: {
        description: 'Controls visibility of the event location in additional info when item is expanded.',
      },
    },
  },
  listShowDateV2: {
    type: StyleParamType.Boolean,
    getDefaultValue: params => getWidgetDateVisibilityDefault(params, deprecatedStyles),
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
      ai: {
        description: 'Controls visibility of the event date.',
      },
    },
  },
  listShowLocationV2: {
    type: StyleParamType.Boolean,
    getDefaultValue: params => getWidgetLocationVisibilityDefault(params, deprecatedStyles),
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
      ai: {
        description: 'Controls visibility of the event location.',
      },
    },
  },
  listLocationAndDateFormatV2: {
    type: StyleParamType.Number,
    getDefaultValue: params => getWidgetLocationDateFormatDefault(params, deprecatedStyles),
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: LIST_LOCATION_AND_DATE_FORMAT.COMPACT,
      },
      ai: {
        description: 'Location and date format can be: 1 - compact, 2 - full',
      },
    },
  },
  calendarEventBadgeLayout: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.eventBadgeLayout),
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'ref',
        ref: 'eventBadgeLayout',
      },
    },
  },
  calendarEventBadgeVerticalAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.eventBadgeVerticalAlignment),
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'ref',
        ref: 'eventBadgeVerticalAlignment',
      },
    },
  },
  calendarEventBadgeHorizontalAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.eventBadgeHorizontalAlignment),
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'ref',
        ref: 'eventBadgeHorizontalAlignment',
      },
    },
  },
  calendarEventBadgeStretched: {
    type: StyleParamType.Boolean,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.eventBadgeStretched),
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'ref',
        ref: 'eventBadgeStretched',
      },
    },
  },
  showFirstPriorityEventBadge: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  showSecondPriorityEventBadge: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  showThirdPriorityEventBadge: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  firstPriorityCalendarEventBadgeFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.firstPriorityEventBadgeFont),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'firstPriorityEventBadgeFont',
      },
    },
  },
  secondPriorityCalendarEventBadgeFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.secondPriorityEventBadgeFont),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'secondPriorityEventBadgeFont',
      },
    },
  },
  thirdPriorityCalendarEventBadgeFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.thirdPriorityEventBadgeFont),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'thirdPriorityEventBadgeFont',
      },
    },
  },
  categoryMenuFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 16,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 16,
      },
    },
  },
  firstPriorityCalendarEventBadgeColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.firstPriorityEventBadgeColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'firstPriorityEventBadgeColor',
      },
    },
  },
  secondPriorityCalendarEventBadgeColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.secondPriorityEventBadgeColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'secondPriorityEventBadgeColor',
      },
    },
  },
  thirdPriorityCalendarEventBadgeColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.thirdPriorityEventBadgeColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'thirdPriorityEventBadgeColor',
      },
    },
  },
  firstPriorityCalendarEventBadgeBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.firstPriorityEventBadgeBackgroundColor),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'ref',
        ref: 'firstPriorityEventBadgeBackgroundColor',
      },
    },
  },
  secondPriorityCalendarEventBadgeBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.secondPriorityEventBadgeBackgroundColor),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'ref',
        ref: 'secondPriorityEventBadgeBackgroundColor',
      },
    },
  },
  thirdPriorityCalendarEventBadgeBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.thirdPriorityEventBadgeBackgroundColor),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'ref',
        ref: 'thirdPriorityEventBadgeBackgroundColor',
      },
    },
  },
  firstPriorityCalendarEventBadgeBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.firstPriorityEventBadgeBorderColor),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: {
        type: 'ref',
        ref: 'firstPriorityEventBadgeBorderColor',
      },
    },
  },
  secondPriorityCalendarEventBadgeBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.secondPriorityEventBadgeBorderColor),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: {
        type: 'ref',
        ref: 'secondPriorityEventBadgeBorderColor',
      },
    },
  },
  thirdPriorityCalendarEventBadgeBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.thirdPriorityEventBadgeBorderColor),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: {
        type: 'ref',
        ref: 'thirdPriorityEventBadgeBorderColor',
      },
    },
  },
  firstPriorityCalendarEventBadgeBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.firstPriorityEventBadgeBorderWidth),
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'ref',
        ref: 'firstPriorityEventBadgeBorderWidth',
      },
    },
  },
  secondPriorityCalendarEventBadgeBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.secondPriorityEventBadgeBorderWidth),
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'ref',
        ref: 'secondPriorityEventBadgeBorderWidth',
      },
    },
  },
  thirdPriorityCalendarEventBadgeBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.thirdPriorityEventBadgeBorderWidth),
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'ref',
        ref: 'thirdPriorityEventBadgeBorderWidth',
      },
    },
  },
  firstPriorityCalendarEventBadgeTopLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) =>
      getStyleParamValue(widgetStyles.firstPriorityEventBadgeTopLeftBorderRadius),
    metadata: {
      type: StyleType.borderTopLeftRadius,
      defaultValue: {
        type: 'ref',
        ref: 'firstPriorityEventBadgeTopLeftBorderRadius',
      },
    },
  },
  firstPriorityCalendarEventBadgeTopRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) =>
      getStyleParamValue(widgetStyles.firstPriorityEventBadgeTopRightBorderRadius),
    metadata: {
      type: StyleType.borderTopRightRadius,
      defaultValue: {
        type: 'ref',
        ref: 'firstPriorityEventBadgeTopRightBorderRadius',
      },
    },
  },
  firstPriorityCalendarEventBadgeBottomLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) =>
      getStyleParamValue(widgetStyles.firstPriorityEventBadgeBottomLeftBorderRadius),
    metadata: {
      type: StyleType.borderBottomLeftRadius,
      defaultValue: {
        type: 'ref',
        ref: 'firstPriorityEventBadgeBottomLeftBorderRadius',
      },
    },
  },
  firstPriorityCalendarEventBadgeBottomRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) =>
      getStyleParamValue(widgetStyles.firstPriorityEventBadgeBottomRightBorderRadius),
    metadata: {
      type: StyleType.borderBottomRightRadius,
      defaultValue: {
        type: 'ref',
        ref: 'firstPriorityEventBadgeBottomRightBorderRadius',
      },
    },
  },
  secondPriorityCalendarEventBadgeTopLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) =>
      getStyleParamValue(widgetStyles.secondPriorityEventBadgeTopLeftBorderRadius),
    metadata: {
      type: StyleType.borderTopLeftRadius,
      defaultValue: {
        type: 'ref',
        ref: 'secondPriorityEventBadgeTopLeftBorderRadius',
      },
    },
  },
  secondPriorityCalendarEventBadgeTopRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) =>
      getStyleParamValue(widgetStyles.secondPriorityEventBadgeTopRightBorderRadius),
    metadata: {
      type: StyleType.borderTopRightRadius,
      defaultValue: {
        type: 'ref',
        ref: 'secondPriorityEventBadgeTopRightBorderRadius',
      },
    },
  },
  secondPriorityCalendarEventBadgeBottomLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) =>
      getStyleParamValue(widgetStyles.secondPriorityEventBadgeBottomLeftBorderRadius),
    metadata: {
      type: StyleType.borderBottomLeftRadius,
      defaultValue: {
        type: 'ref',
        ref: 'secondPriorityEventBadgeBottomLeftBorderRadius',
      },
    },
  },
  secondPriorityCalendarEventBadgeBottomRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) =>
      getStyleParamValue(widgetStyles.secondPriorityEventBadgeBottomRightBorderRadius),
    metadata: {
      type: StyleType.borderBottomRightRadius,
      defaultValue: {
        type: 'ref',
        ref: 'secondPriorityEventBadgeBottomRightBorderRadius',
      },
    },
  },
  thirdPriorityCalendarEventBadgeTopLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) =>
      getStyleParamValue(widgetStyles.thirdPriorityEventBadgeTopLeftBorderRadius),
    metadata: {
      type: StyleType.borderTopLeftRadius,
      defaultValue: {
        type: 'ref',
        ref: 'thirdPriorityEventBadgeTopLeftBorderRadius',
      },
    },
  },
  thirdPriorityCalendarEventBadgeTopRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) =>
      getStyleParamValue(widgetStyles.thirdPriorityEventBadgeTopRightBorderRadius),
    metadata: {
      type: StyleType.borderTopRightRadius,
      defaultValue: {
        type: 'ref',
        ref: 'thirdPriorityEventBadgeTopRightBorderRadius',
      },
    },
  },
  thirdPriorityCalendarEventBadgeBottomLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) =>
      getStyleParamValue(widgetStyles.thirdPriorityEventBadgeBottomLeftBorderRadius),
    metadata: {
      type: StyleType.borderBottomLeftRadius,
      defaultValue: {
        type: 'ref',
        ref: 'thirdPriorityEventBadgeBottomLeftBorderRadius',
      },
    },
  },
  thirdPriorityCalendarEventBadgeBottomRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) =>
      getStyleParamValue(widgetStyles.thirdPriorityEventBadgeBottomRightBorderRadius),
    metadata: {
      type: StyleType.borderBottomRightRadius,
      defaultValue: {
        type: 'ref',
        ref: 'thirdPriorityEventBadgeBottomRightBorderRadius',
      },
    },
  },
  calendarTopMargin: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listTopMargin),
    metadata: {
      type: StyleType.marginTop,
      defaultValue: {
        type: 'ref',
        ref: 'listTopMargin',
      },
    },
  },
  calendarBottomMargin: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listBottomMargin),
    metadata: {
      type: StyleType.marginBottom,
      defaultValue: {
        type: 'ref',
        ref: 'listBottomMargin',
      },
    },
  },
  calendarLeftMargin: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listLeftMargin),
    metadata: {
      type: StyleType.marginLeft,
      defaultValue: {
        type: 'ref',
        ref: 'listLeftMargin',
      },
    },
  },
  calendarRightMargin: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listRightMargin),
    metadata: {
      type: StyleType.marginRight,
      defaultValue: {
        type: 'ref',
        ref: 'listRightMargin',
      },
    },
  },
  calendarHeight: {
    type: StyleParamType.Number,
    getDefaultValue: ({isMobile}) => (isMobile ? 400 : 840),
    metadata: {
      type: StyleType.height,
      defaultValue: {
        type: 'static',
        value: 840,
      },
    },
  },
  calendarGridTopPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.paddingTop,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarGridBottomPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.paddingBottom,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarGridLeftPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.paddingLeft,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarGridRightPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.paddingRight,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarGridHorizontalGap: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.gap,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarGridVerticalGap: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.gap,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarGridBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 0),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
    },
  },
  calendarGridBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  calendarGridBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarGridTopLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderTopLeftRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarGridTopRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderTopRightRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarGridBottomLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderBottomLeftRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarGridBottomRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderBottomRightRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarGridBoxShadowVisible: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
    },
  },
  calendarGridBoxShadowDistance: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarGridBoxShadowAngle: {
    type: StyleParamType.Number,
    getDefaultValue: () => 135,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 135,
      },
    },
  },
  calendarGridBoxShadowBlur: {
    type: StyleParamType.Number,
    getDefaultValue: () => 25,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 25,
      },
    },
  },
  calendarGridBoxShadowColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.12),
    metadata: {
      type: StyleType.color,
      defaultValue: {...wixColor(CssColor.WstParagraph2Color), opacity: 0.12},
    },
  },
  calendarCellTopLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderTopLeftRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarCellTopRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderTopRightRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarCellBottomLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderBottomLeftRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarCellBottomRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderBottomRightRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarCellBoxShadowVisible: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
    },
  },
  calendarCellBoxShadowDistance: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarCellBoxShadowAngle: {
    type: StyleParamType.Number,
    getDefaultValue: () => 135,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 135,
      },
    },
  },
  calendarCellBoxShadowBlur: {
    type: StyleParamType.Number,
    getDefaultValue: () => 25,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 25,
      },
    },
  },
  calendarCellBoxShadowColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.12),
    metadata: {
      type: StyleType.color,
      defaultValue: {...wixColor(CssColor.WstParagraph2Color), opacity: 0.12},
    },
  },
  calendarHeaderTitleFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listTitleFontV2),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'listTitleFontV2',
      },
    },
  },
  calendarHeaderCategoryButtonFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 16,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 16,
      },
    },
  },
  calendarHeaderCategoryButtonColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  calendarHeaderTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listGeneralTitleColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'listGeneralTitleColor',
      },
    },
  },
  calendarHeaderBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  calendarHeaderBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 0),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
    },
  },
  calendarHeaderBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarHeaderTopLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderTopLeftRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarHeaderTopRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderTopRightRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarHeaderBottomLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderBottomLeftRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarHeaderBottomRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderBottomRightRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarHeaderTopPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.paddingTop,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarHeaderRightPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.paddingRight,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarHeaderBottomPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.paddingBottom,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarHeaderLeftPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.paddingLeft,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarHeaderBoxShadowVisible: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
    },
  },
  calendarHeaderBoxShadowDistance: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarHeaderBoxShadowAngle: {
    type: StyleParamType.Number,
    getDefaultValue: () => 135,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 135,
      },
    },
  },
  calendarHeaderBoxShadowBlur: {
    type: StyleParamType.Number,
    getDefaultValue: () => 25,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 25,
      },
    },
  },
  calendarHeaderBoxShadowColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.12),
    metadata: {
      type: StyleType.color,
      defaultValue: {...wixColor(CssColor.WstParagraph2Color), opacity: 0.12},
    },
  },
  calendarHeaderDatePickerButtonFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 16,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 16,
      },
    },
  },
  calendarHeaderDatePickerButtonColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  calendarCellTopPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 12,
    metadata: {
      type: StyleType.paddingTop,
      defaultValue: {
        type: 'static',
        value: 12,
      },
    },
  },
  calendarCellBottomPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 8,
    metadata: {
      type: StyleType.paddingBottom,
      defaultValue: {
        type: 'static',
        value: 8,
      },
    },
  },
  calendarCellLeftPadding: {
    type: StyleParamType.Number,
    getDefaultValue: ({isMobile}) => (isMobile ? 12 : 15),
    metadata: {
      type: StyleType.paddingLeft,
      defaultValue: {
        type: 'static',
        value: 15,
      },
    },
  },
  calendarCellRightPadding: {
    type: StyleParamType.Number,
    getDefaultValue: ({isMobile}) => (isMobile ? 12 : 15),
    metadata: {
      type: StyleType.paddingRight,
      defaultValue: {
        type: 'static',
        value: 15,
      },
    },
  },
  calendarCellHorizontalAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => ALIGNMENT.LEFT,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: ALIGNMENT.LEFT,
      },
    },
  },
  calendarPopupHorizontalAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => ALIGNMENT.LEFT,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: ALIGNMENT.LEFT,
      },
    },
  },
  eventsPerCalendarCell: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 1,
      },
    },
  },
  calendarWeekdaysHorizontalAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => ALIGNMENT.LEFT,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: ALIGNMENT.LEFT,
      },
    },
  },
  calendarWeekdaysBottomMargin: {
    type: StyleParamType.Number,
    getDefaultValue: () => 10,
    metadata: {
      type: StyleType.marginBottom,
      defaultValue: {
        type: 'static',
        value: 10,
      },
    },
  },
  calendarLayoutType: {
    type: StyleParamType.Number,
    getDefaultValue: () => CALENDAR_LAYOUT.MONTHLY,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: CALENDAR_LAYOUT.MONTHLY,
      },
      ai: {
        description: 'Calendar layout type can be: 1 - monthly, 2 - weekly',
      },
    },
  },
  calendarPopupTopPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
    metadata: {
      type: StyleType.paddingTop,
      defaultValue: {
        type: 'static',
        value: 16,
      },
    },
  },
  calendarPopupBottomPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
    metadata: {
      type: StyleType.paddingBottom,
      defaultValue: {
        type: 'static',
        value: 16,
      },
    },
  },
  calendarPopupLeftPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
    metadata: {
      type: StyleType.paddingLeft,
      defaultValue: {
        type: 'static',
        value: 16,
      },
    },
  },
  calendarPopupRightPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
    metadata: {
      type: StyleType.paddingRight,
      defaultValue: {
        type: 'static',
        value: 16,
      },
    },
  },
  calendarSoldOutRibbonFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.soldOutRibbonFont),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'soldOutRibbonFont',
      },
    },
  },
  calendarRsvpClosedRibbonFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.rsvpClosedRibbonFont),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'rsvpClosedRibbonFont',
      },
    },
  },
  calendarJoinWaitlistRibbonFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.joinWaitlistRibbonFont),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'joinWaitlistRibbonFont',
      },
    },
  },
  calendarMembershipRibbonFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.membershipRibbonFont),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'membershipRibbonFont',
      },
    },
  },
  calendarRecurringRibbonFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.recurringRibbonFont),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'recurringRibbonFont',
      },
    },
  },
  calendarSoldOutRibbonTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.soldOutRibbonTextColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'soldOutRibbonTextColor',
      },
    },
  },
  calendarRsvpClosedRibbonTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.rsvpClosedRibbonTextColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'rsvpClosedRibbonTextColor',
      },
    },
  },
  calendarJoinWaitlistRibbonTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.joinWaitlistRibbonTextColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'joinWaitlistRibbonTextColor',
      },
    },
  },
  calendarMembershipRibbonTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.membershipRibbonTextColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'membershipRibbonTextColor',
      },
    },
  },
  calendarRecurringRibbonTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.recurringRibbonTextColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'recurringRibbonTextColor',
      },
    },
  },
  calendarSoldOutRibbonBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.soldOutRibbonBackgroundColor),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'ref',
        ref: 'soldOutRibbonBackgroundColor',
      },
    },
  },
  calendarRsvpClosedRibbonBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.rsvpClosedRibbonBackgroundColor),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'ref',
        ref: 'rsvpClosedRibbonBackgroundColor',
      },
    },
  },
  calendarJoinWaitlistRibbonBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.joinWaitlistRibbonBackgroundColor),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'ref',
        ref: 'joinWaitlistRibbonBackgroundColor',
      },
    },
  },
  calendarMembershipRibbonBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.membershipRibbonBorderColor),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: {
        type: 'ref',
        ref: 'membershipRibbonBorderColor',
      },
    },
  },
  calendarRecurringRibbonBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.recurringRibbonBorderColor),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: {
        type: 'ref',
        ref: 'recurringRibbonBorderColor',
      },
    },
  },
  calendarImageRatio: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.multiImageRatio),
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'ref',
        ref: 'multiImageRatio',
      },
    },
  },
  calendarImageScaling: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.multiImageScaling),
    metadata: {
      type: StyleType.numberEnum,
      defaultValue: {
        type: 'ref',
        ref: 'multiImageScaling',
      },
    },
  },
  calendarImageTopMargin: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.multiImageTopMargin),
    metadata: {
      type: StyleType.marginTop,
      defaultValue: {
        type: 'ref',
        ref: 'multiImageTopMargin',
      },
    },
  },
  calendarImageBottomMargin: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.multiImageBottomMargin),
    metadata: {
      type: StyleType.marginBottom,
      defaultValue: {
        type: 'ref',
        ref: 'multiImageBottomMargin',
      },
    },
  },
  calendarImageLeftMargin: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.multiImageLeftMargin),
    metadata: {
      type: StyleType.marginLeft,
      defaultValue: {
        type: 'ref',
        ref: 'multiImageLeftMargin',
      },
    },
  },
  calendarImageRightMargin: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.multiImageRightMargin),
    metadata: {
      type: StyleType.marginRight,
      defaultValue: {
        type: 'ref',
        ref: 'multiImageRightMargin',
      },
    },
  },
}

export const getNumbersAndBooleans = (stylesValues: Record<string, any>) =>
  Object.entries(styleParams).reduce((acc, [key, value]) => {
    if (value.type === StyleParamType.Boolean || value.type === StyleParamType.Number) {
      acc[key] = stylesValues[key]

      return acc
    }

    return acc
  }, {})

export default createStylesParams<IStyles>(styleParams)

export {customCssVars} from './custom-css-vars'
